import   React,
       { useEffect,
         useState,
         useRef,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Switch,
         Button,
         ButtonGroup,
         Grid,
         List,
         ListItem,
         ListItemText,
         Container,
         Drawer,
         Divider } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes,
         faBug, 
         faCloudDownloadAlt,
         faClone,
         faGlobe,
         faFlag,
         faCity,
         faUsers,
         faCrown,
         faTrophy,
         faUser,
         faInfoCircle,
         faChevronDown,
         faChevronUp,
         faSun,
         faPlayCircle,
         faMask,
         faExpand,
         faSyncAlt } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import {
         FaSun,         // today
         FaDumbbell,    // condition
         FaHandPointer, // agility
         FaBullsEye,    // skill
         FaStopWatch,   // challenge
         FaRunner,      // mock
         FaFilm,        // film
         FaAnalytics,   // analyze
         FaToolbox,     // admin
         FaMedal,       // score
         FaGlobe,       // geo
         FaCopy,        // copy
         FaExpand,
         } from '../assets/Icons';     //icons: https://fontawesome.com/icons
import Carousel from 'react-bootstrap/Carousel'     // sudo yarn add  react-bootstrap bootstrap@5.0.2
       // ref: https://dzone.com/articles/how-to-use-bootstrap-carousel-in-reactjs
import marquee_styles from '../styles/animation.module.css'         // for auto-scrolling text

import { VIMEO_POST,
         YOUTUBE_POST } from "../util/constants";
import { SwitchUser } from "./Admin";
import { BarGraph } from "./Graph";
import { GATag, sleep } from "../util/tools";
import { makeUserKey, CreateVirtualSession } from '../util/database';

import { processServiceWorkerReload,
         low_target_field_type,
         qualifiedBoard,
         getLeaderBoardTitle,
         getDrillTitle,
         getDrillID,
         arrayValueAscSort,
         arrayValueDesSort,
         arrayTargetHashAscSort,
         arrayPointsDesSort,
         arraySourceTimestampDesSort,
         NOW,
         capitalize } from "../util/util";
//import { unregisterServiceWorker } from '../util/registerServiceWorker';
import { appContext } from "./index";
import { CONSTS, INFO, CONSLOG } from '../util/object'
import { Hourglass } from "../util/spinner";
import { AuthClass } from '../class/AuthClass';
import { SecretMenu } from './Secret';
import { AXOS_VERSION } from '../version';
import { enableDebugMode } from '@tensorflow/tfjs-core';
import { setMaxListeners } from 'events';

import { LoadingBars  } from '../util/spinner'; 
import { InfoOutlined } from '@material-ui/icons';

var auth = new AuthClass();


//
// REUSABLE GLOBAL STYLE
//
export const UTIL_useStyles = makeStyles(theme => ({
    // Progress Spinner
    small_spinner_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '30px',
        height: '30px',
        //background: "red",
    },
    spinner_container: {
        display: "flex",
        marginTop: '1vh',
        width: '200px',
        justifyContent: 'center',
    },

    summary_row: {
        display: "flex",
        width: '100%',
        justifyContent: 'flex-start',
        flexDirection: "row",
    },
    summary_header: {
        fontWeight: 'bold',
        fontSize: '2.4rem',     // '1.3rem',
        color:'#8486a1',
    },
    summary_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '2.3rem',     // 1.2rem
    },

    small_summary_row: {
        display: "flex",
        width: '100%',
        justifyContent: 'flex-start',
        flexDirection: "row",
        padding: '0',
    },
    small_summary_header: {
        fontWeight: 'bold',
        fontSize: '1rem',
        color:'#8486a1',
    },
    small_summary_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '1rem',
    },

    icon_body: {
        color:'#ccc',
        alignSelf: "center",
        width: '30px',
        height: '30px',
        padding: '0',
        margin: '10px',
        transform: 'scale(1.2)',
    },

    logo_icon: {
        color:'#827d7d',
        alignSelf: "center",
    },


    dismiss_icon: {
        color:'#827d7d',
        alignSelf: "center",
        fontSize: "1.4rem"
    },
    dismiss_summary_container: {
        display: 'flex',
        position: 'absolute',
        right: '10px',
        top: '0px',
        justifyContent: 'flex-end',
        margin: '0',
        padding: '0',
        paddingTop: '5px',
        color: 'rgba(200, 200, 240, 0.95)',
        zIndex: '580',
    },
    /*
    warning_text: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
    },
    notice_text: {
        //fontWeight: 'bold',
        fontSize: '1.5rem',
        margin: '20px,'
    },
    */
    game_target: {
        position: 'absolute',
        top: '6000px',      // do not display
        left: '6000px',      // do not display
        backgroundColor: 'red',
        borderRadius: '100%',
        padding: '0',       // VERY IMPORTATNT, FIXED WEIRD SIZING PROB
        margin: '0',
        zIndex: '150',
        //width: CONSTS.GAME_TARGET_SIZE+'px',
        //height: CONSTS.GAME_TARGET_SIZE+'px',
    },

    health_light: {
        position: 'absolute',
        top: '3px',
        left: '3px',
        color:'#5d6a9f',
        alignSelf: "center",
        width: '10px',
        height: '10px',
        padding: '0',
        borderRadius: '5px',
        background: 'red',
        zIndex: '500',
    },

}));    // THIS IS UTIL


// <Mode>  mode setting switch: for recording and slow mo
//
const mode_useStyles = makeStyles(theme => ({
    mode_container: {
        display: "flex",
        padding: '0',
        margin: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: "100%",
        height: "auto",
        flexDirection: "row",
        flexWrap: 'wrap',
        //justifyContent: 'center',
        //maxWidth: "20vw",
        //maxHeight: "500px",
        //alignItems: 'middle',
    },
    mode_text: {
        display: "flex",
		fontSize: '1.04rem',
        color: 'grey', 
        alignSelf: 'center',
        verticalAlign: 'middle',
        margin: '0',
        padding: '0',
        width: 'auto',          //'55%',
		//lineHeight: '1.6',
    },
    ios_root: {
        width: 48,
        height: 30,
        padding: 0,
        margin: theme.spacing(1),
        alignSelf: 'flex-start'
    },
    ios_switchBase: {
        padding: 1,
        /*
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
        */
    },
    ios_thumb: {
        width: 26,
        height: 26,
    },
    ios_track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    ios_checked: {},
    ios_focusVisible: {},
}));

export const Mode = (props) => {
    const classes = mode_useStyles();
    //const { State, Dispatch } = useContext(appContext);

    useEffect(() => {
        //console.log("mode.190:   MODE  ",props.Label,"   value =",props.Value);
    }, [props.Value, props.Label]);

                //<Switch focusVisibleClassName={classes.focusVisible} disableRipple
    return (
        <React.Fragment>
            <Container className={classes.mode_container}>
                <Switch focusVisibleClassName={classes.focusVisible} disableripple
                    classes={{
                        root: classes.ios_root,
                        switchBase: classes.ios_switchBase,
                        thumb: classes.ios_thumb,
                        track: classes.ios_track,
                        checked: classes.ios_checked,
                    }}
                    checked={props.Value}
                    onChange={props.Handler} />

                <Container className={classes.mode_text}>
                    {props.Label}
                </Container>
            </Container>
        </React.Fragment>
    );

}


// <GoBack>  - top nav bar for going back nav
//
const goback_useStyles = makeStyles(theme => ({
    goback_container: {
        //display: "flex",
        //paddingRight: "2vw",      // why?
        //width: "100%",
        //height: "5vh",
        position: "absolute",       // rides on top
        top: '0',
        padding: '0',
        margin: '0',
        width: "100vw",
        maxWidth: "100%",
        height: CONSTS.GOBACK_BAR_HEIGHT1+"px",
        color: 'white',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        zIndex: '380',
    },
    title_container: {
        display: "flex",
        height: '100%',
        width: '100%',
        maxWidth: "100%",
        padding: '0',
        margin: '0',
		//fontSize: '1.6rem',
        //paddingLeft: '3vw',
        flexDirection: "row",
        justifyContent: 'space-between',
        alignSelf: 'center',
    },
    title_left_container: {
        display: "flex",
        padding: '0',
        paddingLeft: '2vw',
        margin: '0',
        flexDirection: "row",
        justifyContent: 'flex-start',
        alignSelf: 'center',
        //width: '80%',
    },
    title_right_container: {
        display: "flex",
        padding: '0',
        margin: '0',
        paddingRight: '2vw',
        flexDirection: "row",
        justifyContent: 'space-between',
        alignSelf: 'center',
        width: 'auto',
    },
    title_text: {
        padding: '0',
		fontSize: '1.3rem',
        paddingLeft: '3vw',
        alignSelf: 'center',
        lineHeight: '1.4rem',
    },
    anon_text: {
        padding: '0',
        paddingLeft: '20px',
		fontSize: '1.3rem',
        paddingLeft: '3vw',
        alignSelf: 'center',
        color: '#fa727fe6',
        lineHeight: '1.4rem',
    },
    back_icon: {
        color:'#eaeaf5',
        alignSelf: "center",
        margin: '0px',
        marginLeft: '8px',
        padding: '0px',
        //marginLeft: '5vw',
        minWidth: '20px',
        width: '40px',
    },
    back_icon_disabled: {
        color:'red',
        alignSelf: "center",
        margin: '0px',
        marginLeft: '8px',
        padding: '0px',
        //marginLeft: '5vw',
        minWidth: '20px',
        width: '40px',
    },
    bug_icon: {
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
    },
    info_icon: {
        color:'#c1c5d8',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
    },
    drawer_panel: {
        background: "#aeb0c9",
    },
    type_icon_container: {
        padding: '0 0 0 10px',
        margin: '0 0 0 5px',
        //margin: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        width: 'auto',
    }
}));

export const GoBack = (props) => {
    const classes = goback_useStyles();
    const Classes = UTIL_useStyles();
    const [ Style, setStyle ] = useState({});
    const { State, Dispatch } = useContext(appContext);
    const [ HealthLightColor, setHealthLightColor ] = useState("grey");
    const [ DisableBackButton, setDisableBackButton ] = useState(true);         // always start disabled
    //const refDisableBackButton = useRef(DisableBackButton); // src: https://upmostly.com/tutorials/settimeout-in-react-components-using-hooks
    //const { State } = useContext(appContext);

    useEffect(() => {
        //setStyle({});

        console.log("goBack.453:      . . . . GOBACK START  time=", parseInt(performance.now()));
        var timer = setTimeout(() => {
            console.log("goBack.441:      . . . . GOBACK: DELAY ENABLE BACK BUTTON   time=", parseInt(performance.now()));
            setDisableBackButton(false);
        }, CONSTS.GOBACK_BUTTON_KLUDGE);

        setHealthLightColor(INFO.health_light_color);
        window.addEventListener('health_light', handleHealthLight, false); // Listen for the event and write session to fb
        return function cleanup() {
            console.log("goBack.377:     ###############  LEAVING GOBACK ---------------   time=", parseInt(performance.now()));
            window.removeEventListener('health_light', handleHealthLight, false); // Listen for the event and write session to fb
            if (timer) {
                clearTimeout(timer);
            }
        };

    }, [1]);

    useEffect(() => {
        var style = {}
        if(props.Color !== undefined) {
            style.backgroundColor = props.Color;
        } else {
            style.backgroundColor = 'rgba(43, 65, 120, 0.95)';
        }
        if(props.ZIndex !== undefined) {
            style.zIndex = props.ZIndex;
        }
        //console.log("goback.336:  style=",style, "  zindx=",props.ZIndex, "  color=",props.Color);
        setStyle(style);
    }, [props.Color, props.ZIndex]);

    useEffect(() => {
    }, [Style]);


    useEffect(() => {
    }, [DisableBackButton]);


    const handleHealthLight = () => {
        //console.log("goback.402:  Update health light =",INFO.health_light_color);
        setHealthLightColor(INFO.health_light_color);
    }


    const handleSettingToggle = () => {
        console.log("goback.372:   Toggle Setting Drawer");
        props.ToggleSetting();
    }


                            //{/*style={{overflowX: 'scroll' }}*/}
            //<Container id="goback1" className={classes.goback_container} style={{ zIndex: ZIndex, backgroundColor: Color }}> 
                        //<Avatar id="avatar" Image={State.photo} />}
                    //{props.Tutorial} 
    return (
        <Container key={props.Title} id="goback1" className={classes.goback_container} style={Style}> 
            <Container key={props.Title+"_bar"} id="title_bar" className={classes.title_container} >
                <Container key={props.Title+"_left"} id="title_left" className={classes.title_left_container} >
                    <div key={props.Title+"_light"} id="health_light" style={{background: HealthLightColor}} className={Classes.health_light} />
                    <Button id="setting_btn" className={classes.bug_icon} onClick={handleSettingToggle} >
                        <Avatar id="avatar1" Image={INFO.avatar} />
                    </Button>

                    <div id="page_title" 
                        className={classes.title_text} >
                        {((props.Title === undefined) || (props.Title === null)) ? "" : props.Title.toUpperCase()}
                    </div>

                    <Container className={classes.type_icon_container}>
                        <TypeIcon Type={props.Type} style={{width: "25px", height: "25px", color: "#d5e0e52b"}}/>
                    </Container >

                    {INFO.anon_mode && <div id="page_title" className={classes.anon_text} >
                        (DEMO)
                    </div>}
                </Container>


                <Container  key={props.Title+"_right"} id="title_right" className={classes.title_right_container} >
                    {props.Bug && 
                    <Button id="bug_btn" className={classes.bug_icon} onClick={props.Bug}>
                        <FontAwesomeIcon 
                            className={classes.bug_icon}
                            icon={faBug}
                            style={{ fontSize: "1.5rem"}} />
                    </Button> }

                    {props.Tutorial &&
                    <Button id="info_btn" className={classes.info_icon} onClick={props.Tutorial}>
                        <FontAwesomeIcon 
                            className={classes.info_icon}
                            icon={faInfoCircle}
                            style={{ fontSize: "1.5rem"}} />
                    </Button> }

                    <Button id="back_btn" 
                            disabled={DisableBackButton} onClick={props.GoBack} className= {classes.back_icon} >
                        <FontAwesomeIcon 
                            className={classes.back_icon}
                            icon={props.Icon}
                            style={{ fontSize: "1.5rem", color: (DisableBackButton === true) ? "#817d7d2e": "#ffffff" }} />
                    </Button>
                </Container>
            </Container>
        </Container>
    )
}


const sendinvite_useStyles = makeStyles(theme => ({
    sendinvite_container_root: {
        display: 'flex',
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        backgroundColor: '#6a696eb3',
        justifyContent: 'center',
    },
    sendinvite_container: {
        display: 'flex',
        position: 'absolute',
        width: '50vw',
        height: '40vh',
        minHeight: '280px',
        minWidth: '300px',
        margin: '0',
        //marginTop: '10vh',
        padding: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        //backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        border: '0px',
        borderRadius: '8px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: 'rgba(230, 230, 230, 0.99)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        zIndex: '600',
    },
    sendinvite_dialog_container: {
        display: 'flex',
        flexDirection: "column",
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        padding: '2vw',
        paddingTop: '2vh',
    },
    control_button: {
        "&:hover": {
            color: 'yellow',        // yellow
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.0rem',
        height: '6vh',
        width: '10vw',
        minWidth: '160px',
        minHeight: '40px',

        margin: '0.7vh auto 2.5vh auto',
        padding: '10px',
        backgroundColor: '#5a6a92f2',
        color: 'white',
        borderRadius: '10px',
        border: '0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        //zIndex: '580',
    },
    invite_token_container: {
        display: 'flex',
        flexDirection: "row",
        justifyContent: 'center',
        marginBottom: '10vh',
    },
    invite_prefix: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '9vw',
        minWidth: '55px',
        height: '30px',
		fontSize: '1.1rem',
        color: '#312f2ff2',
    },
    invite_text: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '50%',
        height: '30px',
		fontSize: '1.1rem',
        color: '#312f2ff2',
        padding: '5px 0 0 5px',
    },
    share_text: {
        display: "flex",
        margin: '0 0 5vh 0',
        padding: '0',
        width: '100%',
        height: '30px',
		fontSize: '0.9rem',
        color: '#090808f2',
        padding: '5px 0 0 5px',
        justifyContent: 'center',
    },
    link_text: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '80%',
        height: '30px',
		fontSize: '0.9rem',
        color: '#312f2ff2',
        padding: '5px 0 0 5px',
        alignSelf: 'flex-end',
    },
    copy_button_container: {
        color:'#827d7d',
        fontSize: "1.4rem",
        background: '#ffffff00',
        boxShadow: 'none',
        marginLeft: '15px',
    },
    copy_icon: {
        color:'#827d7d',
        fontSize: "1.4rem",
        border: '0',
        width: '10%',
    }
}));




//  show send invite dialog, get token from server
//
export const SendInvite = (props) => {
    const classes = sendinvite_useStyles();
    const Classes = UTIL_useStyles();
    const [ Prefix, setPrefix ] = useState("");
    const [ ShowGenerate, setShowGenerate ] = useState(true);
    const PrefixRef = useRef('') 
    //console.log("wait.97:  props=",props);

    function handleCopyLlink () {
        //console.log("bug=",BugRef.current.value);
        var text = document.getElementById('link_text');
        //text.focus()
        //text.select();
        //document.execCommand('copy');

        var text = "clark is great"
        navigator.clipboard.writeText(text).then(function() {
            console.log("copy.579: Copying ",text," to clipboard was successful!");
        }, function(err) {
            console.error('copy.581: Could not copy text: ', err);
        });
    }

    function handleGetToken () {
        //console.log("bug=",BugRef.current.value);
        var prefix = PrefixRef.current.value;
        setPrefix(prefix);
        props.GetToken(prefix);
        setShowGenerate(false);
    }

    return (
        <React.Fragment>
            <Container id="invite_token_root" className={classes.sendinvite_container_root} >
            <Container id="invite_token" className={classes.sendinvite_container} >

                <Container id="invite_dialog" className={classes.sendinvite_dialog_container} 
                            style={{ backgroundColor: props.BarColor}} >
                    <Container id="invite_dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.5rem"}} />
                    </Container>

                    {(ShowGenerate === true) ?
                        <React.Fragment>
                        <Container className={classes.share_text}>
                            CHOOSE A PREFIX OR USE DEFAULT
                        </Container>
                        <Container id="set_invite_token" className={classes.invite_token_container}>
                            <TextField
                                id="invite_prefix"
                                inputRef={PrefixRef}
                                label="prefix" 
                                variant="outlined"
                                defaultValue="INV"
                                size="small"
                                className={classes.invite_prefix}
                            />
                            <Container className={classes.invite_text}>
                                XXXXXXXXXXX
                            </Container>
                        </Container>
                        <Button id="submit_btn" variant="contained" className={classes.control_button} onClick={handleGetToken}>
                            CREATE INVITE
                        </Button>
                        </React.Fragment>

                        :

                        <React.Fragment>
                        <Container className={classes.share_text}>
                            COPY LINK AND PASTE INTO EMAIL OR TEXT
                        </Container>
                        <Container id="final_invite_token" className={classes.invite_token_container}>
                            <Container id="link_text" className={classes.link_text}>
                                https://axos.cc/i=jcd:3283923954
                            </Container>
                            <Button id="copy_btn" variant="contained" className={classes.copy_button_container} onClick={handleCopyLlink}>
                                <FontAwesomeIcon 
                                    className={classes.copy_icon}
                                    icon={faClone}
                                    style={{ fontSize: "1.2rem"}} />
                            </Button>
                        </Container>
                        </React.Fragment>
                    }

                </Container>

            </Container>
            </Container>
        </React.Fragment>
    )
}







const setting_useStyles = makeStyles(theme => ({
    drawer_list: {
        width: 180,
        //backgroundColor: 'yellow',
    },
}));

export const Settings = (props) => {
    const classes = setting_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ GodMode, setGodMode ] = useState(false);

    useEffect(() => {
        console.log("############### Enter Setting    god=",INFO.db_players)
        if ((INFO.db_players !== undefined) && (INFO.db_players !== null)) {
            setGodMode(true);
        }
    
    }, [1]);

    const handleShowInvite = () => {
        console.log("setting.454:  REACHED Send Invite Action...", props);
        props.ShowInvite();
    }

    const handleSetting = () => {
        console.log("setting.214:  REACHED Setting Action...");
    }

    const handleBilling = () => {
        console.log("setting.214:  REACHED Billing Action...");
    }

    const handleSWUpdate = () => {
        console.log("setting.214:  REACHED SW Update Action...");
        processServiceWorkerReload();
    }

    const handleGodMode = () => {
        console.log("setting.780:  REACHED GOD MODE Action...");
        props.ShowAdmin();

    }

    const handleLogout = event => {
        console.log("logout.214:  REACHED Logout Action...  authed=",State.authed);
        window.dispatchEvent(INFO.logout_event);
        auth.logout("/splash", State, setState);
        //setStartDisplay(false);
        //setRefresh(Date.now());
    }


    // axos_version => time when this static react client was build
    // server_axos_version => time when backend version was built, need to check static file
    //
    const getAxosVersion = () => {
        var delta = "";
        if (INFO.server_axos_version  > INFO.axos_version) {
            delta = " (OLD)"
        }
        console.log("axos_version.873:  Get version  this=", INFO.axos_version, " latest=",INFO.server_axos_version);
        return ("v."+INFO.axos_version+delta);
    }


                //<ListItemIcon> <Reload /> </ListItemIcon>
    return (
        <React.Fragment>

            <div key={"main"} className={classes.drawer_list}
                role="presentation"
                onClick={props.Toggle}
                onKeyDown={props.Toggle} >

                <List>
                    {/*<ListItem button key={"setting"} onClick={handleSetting}>
                        <ListItemText primary={"SETTINGS"} />
                    </ListItem>
                    <ListItem button key={"invite"} onClick={handleShowInvite}>
                        <ListItemText primary={"SEND INVITE"} />
                    </ListItem>
                    <ListItem button key={"billing"} onClick={handleBilling}>
                        <ListItemText primary={"BILLING"} />
                    </ListItem>*/}
                    <ListItem button key={"update"} onClick={handleSWUpdate}>
                        <ListItemText primary={"UPDATE"} />
                    </ListItem>
                    <ListItem button key={"logout"} onClick={handleLogout}>
                        <ListItemText primary={"LOGOUT"} />
                    </ListItem>
                    {GodMode && <ListItem button key={"god"} onClick={handleGodMode}>
                        <ListItemText primary={"GOD MODE"} />
                    </ListItem> }
                    <ListItem key={"version"} >
                        <Container style={{fontSize: "0.9rem", padding: "0", color: "#ada8a8"}}> {getAxosVersion()} </Container>
                    </ListItem>
                </List>
            </div>
        </React.Fragment>
    )
}



export const Dismiss = (props) => {
    const classes = goback_useStyles();
    const { State } = useContext(appContext);
    const [ Style, setStyle ] = useState({});

    useEffect(() => {
        //setStyle({});

    }, [1]);

    useEffect(() => {
        var style = {}
        if(props.Color !== undefined) {
            style.backgroundColor = props.Color;
        } else {
            style.backgroundColor = 'rgba(43, 65, 120, 0.95)';
        }
        if(props.ZIndex !== undefined) {
            //style["zIndex"] = props.ZIndex;
            style.zIndex = "420";
        }
        style.color="red";
        console.log("dismiss.419:  style=",style, "  zindx=",props.ZIndex, "  color=",props.Color);
        setStyle(style);
    }, [props.Color, props.ZIndex]);

    useEffect(() => {
    }, [Style]);
                            //{/*style={{overflowX: 'scroll' }}*/}
            //<Container id="goback1" className={classes.goback_container} style={{ zIndex: ZIndex, backgroundColor: Color }}> 
            //<Container key={props.Title} id="dismiss" className={classes.goback_container} style={Style}> 
    return (
            <Container id="dismiss" className={classes.goback_container} style={{ zIndex: "880" }}> 
                <Container className={classes.title_container} >
                    <Container className={classes.title_left_container} >
                        <Avatar id="avatar2" Image={State.photo} />
                        <div id="page_title" 
                            className={classes.title_text} >
                            {((props.Title === undefined) || (props.Title === null)) ? "" : props.Title.toUpperCase()}
                        </div>
                        {INFO.anon_mode && <div id="page_title" className={classes.anon_text} >
                            (DEMO)
                        </div>}
                    </Container>

                    <Container className={classes.title_right_container} >

                        <Button id="info_btn" className={classes.info_icon} onClick={props.Tutorial}>
                            <FontAwesomeIcon 
                                className={classes.info_icon}
                                icon={faInfoCircle}
                                style={{ fontSize: "1.5rem"}} />
                        </Button> 

                        <Button id="back_btn" className={classes.back_icon} onClick={props.GoBack}>
                            <FontAwesomeIcon 
                                className={classes.back_icon}
                                icon={props.Icon}
                                style={{ fontSize: "1.5rem"}} />
                        </Button>
                    </Container>
                </Container>
            </Container>
    )
}



// <Wait>  - show spinner when the system is doing something
//
const wait_useStyles = makeStyles(theme => ({
    wait_container: {
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw',
        justifyContent: 'center',
        backgroundColor: 'rgba(130, 130, 140, 0.9)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        position: 'absolute',
        top: '0',
        left: '0',
        paddingTop: '20vh',
        zIndex: '600',      // 500
    },
    big_wait_container: {
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw',
        justifyContent: 'center',
        backgroundColor: 'rgba(130, 130, 140, 0.9)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        position: 'absolute',
        top: '0',
        left: '0',
        paddingTop: '5vh',
        zIndex: '600',      // 500
    },
    wait0_dialog_container: {
        height: '30vh',
        width: '50vw',
        paddingTop: '0',
        paddingBottom: '15px',
        minHeight: '330px',     //'220px',
        minWidth: '300px',
        justifyContent: 'center',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
    },
    wait_dialog_container: {
        height: '30vh',
        width: '50vw',
        paddingTop: '0',
        paddingBottom: '15px',
        paddingRight: '10px',
        minHeight: '320px',     // '220px',
        minWidth: '450px',      // '300px',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',

        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        flexDirection: "column",
    },
    big_wait_dialog_container: {
        height: '90vh',
        width: '50vw',
        paddingTop: '0',
        paddingBottom: '15px',
        paddingRight: '10px',
        maxHeight: '420px',
        minHeight: '220px',
        minWidth: '440px',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '15px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',

        display: 'flex',
        justifyContent: 'flex-start',
        position: 'relative',
        flexDirection: "column",
    },

    wait_status_container: {
        display: 'flex',
        height: '10%',
        width: '100%',
        padding: '0',
        marginBottom: '10px',
        margin: '0',
        justifyContent: 'center',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        //backgroundColor: 'yellow', 
    },
    wait_text1_container: {
        display: "flex",
        width: "auto",
        padding: '0',
        margin: '0',
        paddingLeft: '10px',
        fontSize: '1.2rem',
        color: 'rgba(200, 200, 240, 0.95)',
    },
    wait_text_container: {
        display: "block",
        padding: '0',
        fontSize: '1.7rem',
        //marginLeft: 'auto',
        //marginRight: 'auto',
        marginTop: '5%',
        textAlign: 'center',
        alignSelf: 'center',
        color: 'rgba(200, 200, 240, 0.95)',
    },
    links_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(200, 200, 240, 0.95)',
        overflow: 'scroll',
        flexDirection: "column",
    },
    secret_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(200, 200, 240, 0.95)',
        overflow: 'scroll',
        flexDirection: "column",
    },
    summary1_container: {
        display: "flex",
        margin: '0',
        marginTop: '-12px',
        padding: '15px 0 10px 0',
        width: '100%',
        minHeight: '80px',
        color: 'rgba(200, 200, 240, 0.98)',
        flexDirection: "column",
        overflowY: 'auto',
    },
    summary_title: {
        display: "flex",
        margin: '5px 0px',
        textAlign: 'center',
        alignSelf: 'center',
        fontSize: '2.4rem',     // '1.3rem',
        fontWeight: 'bold',
        color: '#8587a4',       // '#c8c8f0fa',
    },
    control_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.0rem',
        height: '6vh',
        width: '10vw',
        minWidth: '160px',
        minHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '2.5vh',
        marginTop: '0.7vh',
        padding: '10px',
        //backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        backgroundColor: '#5a6a92f2',
        color: 'white',
        borderRadius: '10px',
        border: '0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '580',
    },
    dismiss_button_container: {
        display: "flex",
        margin: '10px',
        textAlign: 'center',
        alignSelf: 'center',
        zIndex: '580',
    },
    warning_text: {
        fontSize: '1.2rem',
        padding: '0',
        margin: '20px',
    },
    buttons_container: {
        fontSize: '1.1rem',
        padding: '0',
        margin: '10px 0 30px 0',
        height: 'auto',
        width: '100%',
    },
    buttons_row: {
        fontSize: '1.0rem',
        padding: '0 0 0 20px',
        margin: '0 10px 5px 10px',
        color: 'white',
    },
    buttons_text: {
        //fontSize: '1.2rem',
        padding: '0',
        margin: '0 10px 0 0',
        color: 'white',
    },
    report_text: {
        fontSize: '1.2rem',
        padding: '0',
        margin: '20px',
    },
    notice_text: {
        fontSize: '1.5rem',
        padding: '0',
        margin: '20px',
    },
    confirmation_text: {
        fontSize: '1.3rem',
        padding: '0',
        margin: '0px',
        textAlign: 'center',
        color: "#888",
    },
    report_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        color: 'rgba(200, 200, 240, 0.98)',
        flexDirection: "column",
        overflowY: 'auto',
        height: '80%',
        //marginTop: '-12px',
    },
    report_header: {
        fontWeight: 'bold',
        fontSize: '1.2rem',
    },
    report_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '1.1rem',
    },

}));

export const Wait = (props) => {
    const classes = wait_useStyles();
    const Classes = UTIL_useStyles();

    const [ Links, setLinks ] = useState([]);
    const [ Summary, setSummary ] = useState([]);
    const [ Report, setReport ] = useState();
    const [ Warning, setWarning ] = useState();
    const [ Notice, setNotice ] = useState();
    const [ Secret, setSecret ] = useState(false);
    const [ HasValid, setHasValid ] = useState(false);
    const [ HasPublic, setHasPublic ] = useState(false);
    const [ ShowSubmit, setShowSubmit ] = useState(false);
    const [ Title, setTitle ] = useState("");
    const [ PublicYesColor, setPublicYesColor ] = useState("grey");
    const [ PublicNoColor, setPublicNoColor ] = useState("grey");
    const [ ValidYesColor, setValidYesColor ] = useState("grey");
    const [ ValidNoColor, setValidNoColor ] = useState("grey");

    //console.log("wait.97:  props=",props);
    useEffect(() => {
        if(props.Links !== undefined) {
            setLinks([...props.Links]);  // save a copy of array
        }
        if(props.Summary !== undefined) {
            setSummary([...props.Summary]);  // save a copy of array
        }
        if(props.Warning !== undefined) {
            setWarning(props.Warning);
        }
        if(props.Report !== undefined) {
            //setReport([...props.Report]);  // save a copy of array
            setReport(props.Report);  // save a copy of array
        }
        if(props.Notice !== undefined) {
            setNotice(props.Notice);
        }

        if(props.Outcome !== undefined) {
            setTitle(props.Outcome);
        }

        if(props.Secret !== undefined) {
            setSecret(props.Secret);        // secret admin menu
        }

        if(props.ValidateRun !== undefined) {
            setValidYesColor(OFF)
            setValidNoColor(OFF)
            setPublicYesColor(ON)
            setPublicNoColor(OFF)
            INFO.make_record_public = true;     // default to public
        }
        console.log("wait.1263:   # # # # # <WAIT>  props.Summary=",props.Summary);
        return function cleanup() {
            console.log("wait.1265:   ! ! ! ! ! <WAIT>  EXIT");
        }
    }, [1]);

    useEffect(() => {
    }, [Summary, Links, Warning, Notice]);

    useEffect(() => {
        //console.log("wait.490:  props.ButtonText=",props.ButtonText);
        if(props.Links !== undefined) {
            setLinks([...props.Links]);  // save a copy of array
        }
        if(props.Summary !== undefined) {
            setSummary([...props.Summary]);  // save a copy of array
        }
        if(props.Report !== undefined) {
            setWarning(props.Report);
        }
        if(props.Warning !== undefined) {
            setWarning(props.Warning);
        }
        if(props.Notice !== undefined) {
            setNotice(props.Notice);       // Notice has bigger fonts
        }
        console.log("wait.1286:   # # # # # <WAIT> REFRESH props.Summary=",props.Summary);
    }, [props.Summary, props.Links, props.Warning, props.Report, props.Confirmation, props.Notice, props.ButtonText]);


    const ON = "#109b10"
    const OFF = "#b6b1b147"
    const handleValid = (valid) => (event) => {
        console.log("valid.1194:  Process Valid Btn  ", valid);
        INFO.make_record_public = null;
        if (valid === false){
            setTitle("RUN COMPLETED");
            setShowSubmit(true);
            setHasValid(false);
            setValidYesColor(OFF)
            setValidNoColor(ON)
        } else {
            setTitle(props.Outcome);
            setShowSubmit(true);
            setHasValid(true);
            setValidYesColor(ON)
            setValidNoColor(OFF)
        }
    }

    const handlePublic = pub => (event) => {
        console.log("valid.1194:  Process Public Btn  ", pub);
        setShowSubmit(true);
        if(pub === true) {
            setPublicYesColor(ON)
            setPublicNoColor(OFF)
            INFO.make_record_public = true;
        } else {
            setPublicYesColor(OFF)
            setPublicNoColor(ON)
            INFO.make_record_public = false;
        }
    }

    // <Wait> PROPS:
    //     Multi-purpose dialog box to inform or status or show secret menu
    //     - Dismiss <Handler>: Show upper right Dismss "X"
    //     - ButtonText <text>: Display button at bottom if not null
    //     - ButtonAction <Handler>: Handler when button is clicked
    //     - ShowSpinner <true>: Display wait spinner
    //     - Links [ {title: <t1>, value: <v1>} ]: Display a list of clickable URL links
    //     - Summary [ {title: <t1>, value: <v1>} ]: Display a list of results
    //     - Warning <text>: Display message
    //     - Notice <text>: Display message
    //     - ValidateRun <text>: Accepts and publishs a run result
    //     - Secret: Show secret admin menu
    return (
        <React.Fragment>
            <Container id="wait" className={(props.ValidateRun === true) ? classes.big_wait_container : classes.wait_container} >

                <Container id="wait_dialog" className={(props.ValidateRun === true) ? classes.big_wait_dialog_container : classes.wait_dialog_container} >
                    {props.Dismiss && !props.ValidateRun && <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.4rem"}} />
                    </Container>}

                    {(Links.length > 0) && <Container id="links_container" className={classes.links_container}>
                        {Links.map((link, index) =>
                            <li key={"link_"+index} id={"link_"+index} >
                                <a href={link.value}>
                                    {link.title} 
                                </a>
                            </li>
                        )}
                    </Container> }

                    {props.Outcome && 
                    <Typography id="header_container" className={classes.summary_title}>
                        {Title}
                    </Typography>}

                    {(Summary.length > 0) && <Container id="summary_container" className={classes.summary1_container}>
                        {Summary.map((summary, index) =>
                            <Container key={"sum"+index} className={Classes.summary_row}>
                                <Typography className={Classes.summary_header}> {summary.title} </Typography>
                                <Typography className={Classes.summary_value}> {summary.value} </Typography>
                            </Container>
                        )}
                    </Container> }

                    {Report && <Container id="report_container" className={classes.report_container}>
                        <Typography className={classes.report_header}> {Report.title} </Typography>
                        <Typography className={classes.report_value}> {Report.value} </Typography>
                    </Container> }

                    {Warning && <Container id="warning_container" className={classes.summary_container}>
                        <Typography className={classes.warning_text}> {Warning} </Typography>
                    </Container> }

                    {Notice && <Container id="notice_container" className={classes.summary_container}>
                        <Typography className={classes.notice_text}> {Notice} </Typography>
                    </Container> }

                    {Secret && <SecretMenu id="notice_container" 
                                ConsLog={props.ConsLog}
                                className={classes.secret_container} /> }


                    {(props.ValidateRun === true) ?
                        <React.Fragment>
                            <Container id="buttons_container" className={classes.buttons_container}>
                                <div className={classes.buttons_text}> RESULT VALID? </div>
                                <ButtonGroup size="small" className={classes.buttons_row}>
                                    <Button style={{background: ValidYesColor}} onClick={handleValid(true)}> YES </Button>
                                    <Button style={{background: ValidNoColor}} onClick={handleValid(false)}> NO </Button>
                                </ButtonGroup>

                                {HasValid && <React.Fragment>
                                    <div className={classes.buttons_text}> LEADERBOARD ADD? </div>
                                    <ButtonGroup size="small" className={classes.buttons_row}>
                                        <Button style={{background: PublicYesColor}} onClick={handlePublic(true)}> YES </Button>
                                        <Button style={{background: PublicNoColor}} onClick={handlePublic(false)}> NO </Button>
                                    </ButtonGroup>
                                </React.Fragment>}
                            </Container>

                            {ShowSubmit && <Button id="submit_btn" variant="contained" className={classes.control_button} onClick={props.Submit}>
                                SUBMIT
                            </Button>}
                        </React.Fragment>
                    :
                        <React.Fragment>
                            {props.ShowSpinner && 
                                <Container id="wait_status" className={classes.wait_status_container} >
                                    <Container id="spinner_container" className={Classes.small_spinner_container}>
                                        <Hourglass size={15} color="#be97e8" />
                                    </Container>
                                    <Container id="wait_msg" className={classes.wait_text1_container} >
                                        PLEASE WAIT...{props.Progress}
                                    </Container>
                                </Container>
                            }

                            {props.Confirmation &&
                                <Typography className={classes.confirmation_text}> {props.Confirmation} </Typography>
                            }
                        </React.Fragment>
                    }


                    {props.ButtonAction && <Container id="dismiss" className={classes.dismiss_button_container} >
                        {(props.ButtonText !== null) ?
                            <Button id="wait_btn" variant="contained" disabled={props.DisableRun} className={classes.control_button} onClick={props.ButtonAction}>
                                { props.ButtonText }
                            </Button>
                        :
                            <Button id="disabled_btn" variant="contained" disabled={true} className={classes.control_button} onClick={props.ButtonAction}>
                                WAIT...
                            </Button>
                        }
                    </Container>}

                </Container>

            </Container>
        </React.Fragment>
    )
}



// <Notice>  - show practice loop instruction on top of content
//
const notice_useStyles = makeStyles(theme => ({
    notice_container: {
        //position: 'absolute',
        //top: '50px',
        //left: '0',
        width: '100%',
        maxWidth: '100%',
        height: '50px',
        margin: '0',
        padding: '0',
        justifyContent: 'center',
        zIndex: '190',      // was 140, 100
        //transform: 'translateY(50px)',
        backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
    },
    notice_dialog_container: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 0, 0.9)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '0px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        paddingTop: '8px',
        zIndex: '390',
    },
    small_notice_dialog_container: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 0, 0.9)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        borderRadius: '0px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        padding: '10px 0 0 10px',
        zIndex: '390',
    },
    blank_notice_dialog_container: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        zIndex: '0',
    },
    notice_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(255, 0, 0, 0.95)',
        flexDirection: "column",
    },
    small_notice_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(255, 0, 0, 0.95)',
        flexDirection: "column",
    },
    summary_row1: {
        display: "flex",
        width: '100%',
        justifyContent: 'flex-start',
        flexDirection: "row",
        padding: '0',
    },
    summary_header: {
        fontWeight: 'bold',
        fontSize: '1.7rem',
    },
    summary_value: {
        paddingLeft: '15px',
        fontWeight: 'normal',
        fontSize: '1.6rem',     //'1.2rem',
    },

    small_summary_row1: {
        display: "flex",
        width: '100%',
        justifyContent: 'flex-start',
        flexDirection: "row",
        padding: '0',
    },
    small_summary_header: {
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    small_summary_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '1rem',
    },

}));


// in-game instructions
//
export const Notice = (props) => {
    const classes = notice_useStyles();
    const Classes = UTIL_useStyles();
    //console.log("wait.97:  props=",props);
    // summary = [ {title: <t1>, value: <v1>} ]
    useEffect(() => {
        //console.log("Notice.1247: ########### START <NOTICE>  display=",props.Display, " barColor=",props.BarColor, " Instrns=",props.Instrns);
    }, [ 1 ]);

    return (
        <React.Fragment>
            <Container id="notice_steps" className={classes.notice_container} style={props.Style} >

                {(props.Display === true) ?
                    <Container id="notice_dialog" className={ (props.SmallSize === true) ? classes.small_notice_dialog_container : classes.notice_dialog_container} 
                                style={{ backgroundColor: props.BarColor}} >
                        <Container id="steps_summary_container" 
                                    className={(props.SmallSize === true) ?
                                                    classes.small_notice_text_container
                                                :
                                                    classes.notice_text_container
                                              }
                                style={{ color: props.FontColor, backgroundColor: props.BarColor}} >
                            {props.Instrns.map((summary, index) => {
                                return(
                                    (props.SmallSize === true) ?
                                        <Container key={"sum"+index} className={classes.small_summary_row1}>
                                            <Typography className={classes.small_summary_header}> {summary.title} </Typography>
                                            <Typography className={classes.small_summary_value}> {summary.value} </Typography>
                                        </Container>
                                    :
                                        <Container key={"sum"+index} className={classes.summary_row1}>
                                            <Typography className={classes.summary_header}> {summary.title} </Typography>
                                            <Typography className={classes.summary_value}> {summary.value} </Typography>
                                        </Container>
                                )
                            }) }
                        </Container>
                    </Container>
                :
                    ""
                }

            </Container>
        </React.Fragment>
    )
}


// PWA Notifications
//     - Use Safari
//
const pwa_notice_useStyles = makeStyles(theme => ({
    pwa_notice_container: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        height: '500px',
        margin: '0',
        padding: '0',
        justifyContent: 'center',
        zIndex: '190',      // was 140, 100
        backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        //transform: 'translateY(50px)',
    },
    pwa_notice_dialog: {
        flexDirection: "column",
        position: 'relative',
        height: '80%',
        width: '100%',
        maxWidth: '100%',
        paddingTop: '8px',
        marginTop: '20px',
        justifyContent: 'center',
        borderRadius: '0px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        color: '#444444f2',
        zIndex: '390',
    },
    chrome_title_text_container: {
        display: "flex",
        margin: '0',
        padding: '10px 30px 30px 0',
        width: '100%',
        height: '70px',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        textAlign: 'center',
        flexDirection: "column",
    },
    safari_title_text_container: {
        display: "flex",
        margin: '0',
        padding: '0 20px 10px 0',
        width: '100%',
        height: '50px',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        textAlign: 'center',
        flexDirection: "column",
    },
    notice_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        fontSize: '0.9rem',
        flexDirection: "column",
        textHeight: '1.8rem',

        overflow: 'scroll',
        height: '80%',
    },
    copy_btn_container: {
        display: "flex",
        width: '100%',
        height: 'auto',
        margin: '0',
        padding: '20px 0 0 60px',
        flexDirection: "row",
        alignItems: 'center',
    },
    copied_input_field: {
        height: 'auto',
        background: 'none',
        width: '70%',
        border: 'none',
        borderWidth: '0px',
        fontSize: '1.1rem',
        fontStyle: 'italic',
        textAlign: 'center',
        color: '#372d9332',
    },
    input_field: {
        height: 'auto',
        background: 'none',
        width: '70%',
        border: 'none',
        borderWidth: '0px',
        fontSize: '1.1rem',
        fontStyle: 'italic',
        textAlign: 'center',
    },
    copy_button: {
        display: 'flex',
        height: '40px',
        width: '40px',
        alignSelf: 'center',
        justifySelf: 'center',
        margin: '20px 20px',       // auto',
        color: '#372d93f2',
    },
    ok_button: {
        display: 'flex',
        width: '100px',
        height: 'auto',
        alignSelf: 'center',
        justifySelf: 'center',
        margin: '20px auto',       // auto',
        fontSize: '1rem',
        color: '#372d93f2',
    },
    safari_icon: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: '45px',
        padding: '0',
        margin: '0',
        color: '#88888899',
        zIndex: '300',
    },
    expand_icon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '30px',
        padding: '0',
        margin: '0',
        color: '#88888899',
        zIndex: '300',
    },
    add_home_container: {
        display: 'flex',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        margin: '0',
        padding: '0',
        justifyContent: 'center',
        zIndex: '600',      // was 140, 100
        backgroundColor: '#adababf4',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
    },
    add_home_dialog: {
        position: 'relative',
        width: '80%',
        maxWidth: '550px',
        height: '90%',
        maxHeight: '500px',
        justifyContent: 'center',
        alignSelf: 'center',
        //overflow: 'scroll',
        //margin: '10%',
        paddingTop: '20px',
        zIndex: '600',      // 500
        color: '#444444f2',
        background: '#ffffff',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
    },
    instrn_text: {
        margin: '20px 0 0 0',
        fontSize: '1.0rem',
        fontWeight: 'bold',
    },
    strip_image1: {
        height: 'auto',
        width: '100%',
        maxWidth: '320px',
        justifyContent: 'center',
    },
    strip_image2: {
        height: '50px',
        //width: '100%',
        maxWidth: '320px',
        justifyContent: 'center',
    },
}));


export const NoticePWA = (props) => {
    const classes = pwa_notice_useStyles();
    const Classes = UTIL_useStyles();
    const [ AddHomeBtn, setAddHomeBtn ] = useState(false);


    useEffect(() => {
        //console.log("Notice.1247: ########### START <NOTICE>  display=",props.Display, " barColor=",props.BarColor, " Instrns=",props.Instrns);
        switch (props.Type) {
            case CONSTS.PWA_ADD_IOS_HOME:
            case CONSTS.PWA_ADD_ANDROID_HOME:
                if(INFO.localhost === false) {
                    setAddHomeBtn(true);
                }
                break;
        }

    }, [ 1 ]);



    return (
        <React.Fragment>
            {(props.Type === CONSTS.PWA_USE_SAFARI) &&
                <Container id="pwa_container" className={classes.pwa_notice_container} >

                    <Container id="notice_dialog" className={ classes.pwa_notice_dialog} >
                        <Container id="pwa_title" className= {classes.chrome_title_text_container} >
                            REQUIRES SAFARI BROWSER
                            <img id="safari_icon" src={CONSTS.WEB_ASSET_PATH+"safari_icon.png"} alt="Safari" className={classes.safari_icon} />
                        </Container>
                        <Container id="pwa_text" className= {classes.notice_text_container} >
                            <li> Click to Copy URL Link </li>
                            <li> Open and Paste Link in Safari Browser </li>
                            <Container id="pwa_copy" className= {classes.copy_btn_container} >
                                <input id="copy_target" input="text" value={INFO.starting_url} readOnly="readonly" 
                                className = {(props.Copied === true) ? classes.copied_input_field : classes.input_field}  />
                                <Button id="copy_btn" variant="contained" className={classes.copy_button} onClick={props.Copy}>
                                    <FaCopy className={Classes.icon_body} style={{width: '30px'}} />
                                </Button>
                            </Container>
                        </Container>
                    </Container>
            </Container>
            }

            {AddHomeBtn &&
                <Container id="add_home_container" className={ classes.add_home_container} >
                    <Container id="add_home" className={ classes.add_home_dialog} >
                        <Container id="pwa_title" className= {classes.safari_title_text_container} >
                            RUN IN FULL SCREEN MODE
                        </Container>
                        <Container id="pwa_text_container" className= {classes.notice_text_container} >
                            <li> Axos is Designed for Full Screen Mode </li>
                            <li> Add Icon to Home Screen for Quick Access </li>
                            <li> Steps to Add Quick Launch Button: </li>

                            {(props.Type === CONSTS.PWA_ADD_IOS_HOME) &&
                                <React.Fragment>
                                    <Container id="pwa_text1" className= {classes.instrn_text} >
                                        <p> 1: Click on "Share" </p>
                                        <img id="share_btn" src={CONSTS.WEB_ASSET_PATH+"ios_show_share_btn.png"} alt="" className={classes.strip_image1} />
                                    </Container>

                                    <Container id="pwa_text2" className= {classes.instrn_text} >
                                        <p> 2: Click "Add To Home Screen" </p>
                                        <img id="home_btn" src={CONSTS.WEB_ASSET_PATH+"ios_show_home_btn.png"} alt="" className={classes.strip_image1} />
                                    </Container>
                                </React.Fragment>}

                            {(props.Type === CONSTS.PWA_ADD_ANDROID_HOME) &&
                                <React.Fragment>
                                    <Container id="pwa_text1" className= {classes.instrn_text} >
                                        <p> 1: Click on "Menu" </p>
                                        <img id="share_btn" src={CONSTS.WEB_ASSET_PATH+"android_show_menu_btn.png"} alt="" className={classes.strip_image2} />
                                    </Container>

                                    <Container id="pwa_text2" className= {classes.instrn_text} >
                                        <p> 2: Click "Add To Home Screen" </p>
                                        <img id="home_btn" src={CONSTS.WEB_ASSET_PATH+"android_show_home_btn.png"} alt="" className={classes.strip_image2} />
                                    </Container>
                                </React.Fragment>}

                            <Button id="ok_btn" variant="contained" className={classes.ok_button} onClick={props.Dismiss}>
                                GOT IT!
                            </Button>
                        </Container>

                        <Container className={classes.expand_icon} >
                            <FaExpand className={Classes.icon_body} style={{}} />
                        </Container>
                    </Container>
                </Container>
            }

        </React.Fragment>
    )
}




// <Instruction>  - full page instruction
//
const fullscreen_useStyles = makeStyles(theme => ({
    fullscreen_container: {
        position: 'absolute',
        top: '0',
        right: '0',
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        justifyContent: 'center',
        zIndex: '600',
        background: '#f00',
    },
    directon_dialog_container: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        justifyContent: 'center',
        backgroundColor: '#e0dfef',
        borderRadius: '0px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        paddingTop: '20px',
        zIndex: '390',
    },
    blank_directon_dialog_container: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        zIndex: '0',
    },
    directon_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: '#070654f2',
        flexDirection: "column",
    },
    small_directon_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(255, 0, 0, 0.95)',
        flexDirection: "column",
    },
    fullscreen_message: {
        margin: '30px 0 10px 0',
        padding: '0px',
        width: '100%',
        height: '100%',
        fontSize: '1.6rem',
        textAlign: 'center',
        color: 'red',
    },
    direction_heading: {
        margin: '0 0 10px 0',
        padding: '0px',
        width: '100%',
        height: '100%',
        fontSize: '0.9rem',
    },
    small_summary_row: {
        margin: '0 0 10px 0',
        padding: '0',
        width: '100%',
        height: '100%',
    },
    small_summary_header: {
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    small_summary_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '0.9rem',
    },
    image_container: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        paddingTop: '10vh',
    },
    image: {
        width: "50%",
        alignSelf: "flex-start",
    }

}));


// to display a full screen message
//
export const FullScreen = (props) => {
    const classes = fullscreen_useStyles();
    const Classes = UTIL_useStyles();
    const [ Heading, setHeading ] = useState("");
    const [ Image, setImage ] = useState("");

    //console.log("full_screen.1644:  props.Image",props.Image);


    return (
        <React.Fragment>
            <Container id="fullscreen_notice" className={classes.fullscreen_container} >
                    <Container id="fullscreen_dialog" className={classes.directon_dialog_container} >

                        <Container id="heading" className={classes.fullscreen_message } >
                            {props.Message}
                        </Container>

                        <Container id="heading" className={classes.image_container } >
                            <img src={props.Image} className={classes.image} />
                        </Container>

                        <div id="steps_summary_container" className={classes.directon_text_container }>
                        </div>
                    </Container>

            </Container>
        </React.Fragment>
    )
}


const validaterun_useStyles = makeStyles(theme => ({
    validate_root: {
        display: 'flex',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: '#77777788', 
        zIndex: '600',
    },
    validate_container: {
        display: 'flex',
        position: 'relative',
        flexDirection: "column",
        width: '50vw',
        height: '40vh',
        minHeight: '280px',
        minWidth: '300px',
        marginTop: '10vh',
        padding: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        border: '0px',
        borderRadius: '8px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: 'rgba(230, 230, 230, 0.99)', 
    },
    validate_dialog_container: {
        display: 'flex',
        flexDirection: "column",
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        padding: '2vw',
        paddingTop: '2vh',
    },
    validate_header: {
        display: "flex",
        margin: '0',
        width: '100%',
        //height: '70%',
		fontSize: '1.1rem',
        color: '#312f2ff2',
        //flexDirection: "column",
        //padding: '25px',
    },
    control_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.2rem',
        height: '8vh',
        width: '20vh',
        minWidth: '180px',
        minHeight: '35px',
        maxHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '2vh',
        marginTop: '0.5vh',
        padding: '10px',
        //backgroundColor: 'rgba(20, 70, 162, 0.9)',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',
        color: 'white',
        borderRadius: '10px',
        border: '0',
        boxShadow: '0 10 20 0',
        alignSelf: 'flex-end',
        zIndex: '580',
    },

}));

// dialog to certify a new record run
//
export const ValidateRun = (props) => {
    const classes = validaterun_useStyles();
    const Classes = UTIL_useStyles();
    const [ Heading, setHeading ] = useState("");

    //console.log("full_screen.1757:  props.Message=",props.Message);
    useEffect(() => {
    }, [ props.Message ]);

    return (
        <React.Fragment>
            <Container id="validate_root" className={classes.validate_root} >
                <Container id="validate_notice" className={classes.validate_container} >
                    <Container id="validate_dialog" className={classes.validate_dialog_container} >
                        {false && <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                            <FontAwesomeIcon 
                                className={Classes.dismiss_icon}
                                icon={faTimes}
                                style={{ fontSize: "1.5rem"}} />
                        </Container>}


                        <Container id="heading" className={classes.validate_header } >
                            {props.Message}
                            SESSION DETAIL GOES HERE
                        </Container>

                        <Container id="steps_summary_container" className={classes.directon_text_container } >
                            CONTROL GOES HERE
                        </Container>
                    </Container>

                    <Button id="submit_btn" variant="contained" className={classes.control_button} onClick={event => props.Bug}>
                        SUBMIT
                    </Button>

                </Container>
            </Container>
        </React.Fragment>
    )
}


// in-game instructions
//
const direction_useStyles = makeStyles(theme => ({
    direction_container: {
        position: 'absolute',
        top: CONSTS.GOBACK_BAR_HEIGHT+"px",
        left: '0',
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        justifyContent: 'center',
        zIndex: '200',
        //transform: 'translateY(50px)',
        //backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        background: '#f00',
    },
    directon_dialog_container: {
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        justifyContent: 'center',
        backgroundColor: '#e0dfef',
        borderRadius: '0px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        paddingTop: '20px',
        zIndex: '390',
    },
    blank_directon_dialog_container: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        zIndex: '0',
    },
    directon_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: '#070654f2',
        flexDirection: "column",
    },
    small_directon_text_container: {
        display: "flex",
        margin: '0',
        padding: '0',
        width: '100%',
        height: '70%',
        color: 'rgba(255, 0, 0, 0.95)',
        flexDirection: "column",
    },
    direction_heading: {
        margin: '0 0 10px 0',
        padding: '0px',
        width: '100%',
        //height: '100%',
        fontSize: '0.9rem',
    },
    small_summary_row: {
        margin: '0 0 10px 0',
        padding: '0',
        width: '100%',
        //height: '100%',
    },
    small_summary_header: {
        fontWeight: 'bold',
        fontSize: '1rem',
    },
    small_summary_value: {
        paddingLeft: '10px',
        fontWeight: 'normal',
        fontSize: '0.9rem',
    },

}));

export const Direction = (props) => {
    const classes = direction_useStyles();
    const Classes = UTIL_useStyles();
    const [ Heading, setHeading ] = useState("");

    //console.log("direction.1353:  props.Directions=",props.Directions);

    useEffect(() => {
        if(props.Directions.length > 0) {
            console.log("direction.2194:   .....DIRECTION  Refresh.....",props.Directions);
            setHeading(props.Directions[0].heading);
        }
    }, [ props.Directions ]);


    return (
        <React.Fragment>
            <Container id="direction_container" className={classes.direction_container} style={props.Style} >
                    <Container id="directon_dialog" className={classes.directon_dialog_container} >

                        <Container id="heading" className={classes.direction_heading } >
                            {Heading}
                        </Container>

                        <Container id="steps_summary_container" className={classes.directon_text_container } >
                            {props.Directions && props.Directions.map((summary, index) => {
                                return(
                                    <Grid container key={"sum"+index} className={classes.small_summary_row}>
                                        <Grid item xs={2} className={classes.small_summary_header}> {summary.title} </Grid>
                                        <Grid item xs={10} className={classes.small_summary_value}> 
                                            {summary.value} 
                                            {(summary.link !== undefined) && <a href={summary.link} >{summary.label} </a>}
                                        </Grid>
                                    </Grid>
                                )
                            }) }
                        </Container>
                    </Container>

            </Container>
        </React.Fragment>
    )
}








// <BugReport>  - dialog to collect user bug feedback
//
const bugreport_useStyles = makeStyles(theme => ({
    bugreport_container: {
        display: 'flex',
        position: 'absolute',
        width: '50vw',
        height: '40vh',
        minHeight: '280px',
        minWidth: '300px',
        margin: '0',
        marginTop: '10vh',
        padding: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        //backgroundColor: 'rgba(0, 0, 0, 0)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        border: '0px',
        borderRadius: '8px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: 'rgba(230, 230, 230, 0.99)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        zIndex: '500',
    },
    bugreport_dialog_container: {
        display: 'flex',
        flexDirection: "column",
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        padding: '2vw',
        paddingTop: '2vh',
    },
    blank_bugreport_dialog_container: {
        height: '100%',
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    bugreport_textbox: {
        display: "flex",
        margin: '0',
        padding: '25px',
        width: '100%',
        height: '70%',
		fontSize: '1.1rem',
        color: '#312f2ff2',
        //flexDirection: "column",
    },
    control_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
        },
		fontSize: '1.2rem',
        height: '8vh',
        width: '20vh',
        minWidth: '180px',
        minHeight: '35px',
        maxHeight: '40px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '2vh',
        marginTop: '0.5vh',
        padding: '10px',
        //backgroundColor: 'rgba(20, 70, 162, 0.9)',
        backgroundColor: 'rgba(43, 65, 120, 0.95)',     // Dark Cornflower Blue
        color: 'white',
        borderRadius: '10px',
        border: '0',
        boxShadow: '0 10 20 0',
        alignSelf: 'flex-end',
        zIndex: '580',
    },
}));


//  show input box to report a problem
//
export const BugReport = (props) => {
    const classes = bugreport_useStyles();
    const Classes = UTIL_useStyles();
    const [ BugText, setBugText ] = useState("");
    const BugRef = useRef('') 
    //console.log("wait.97:  props=",props);

    function handleBugInput () {
        //console.log("bug=",BugRef.current.value);
        setBugText(BugRef.current.value);
    }

                        //fullWidth
    return (
        <React.Fragment>
            <Container id="bugreport" className={classes.bugreport_container} >

                <Container id="bugrep_dialog" className={classes.bugreport_dialog_container} 
                            style={{ backgroundColor: props.BarColor}} >
                    <Container id="dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.5rem"}} />
                    </Container>

                    <TextField
                        id="bug_report_text"
                        inputRef={BugRef}
                        className={classes.bugreport_textbox}
                        label="ENTER WHAT IS WRONG?"
                        margin="normal"
                        variant="outlined"
                        style={{ padding: 12 }}     //  style={{ margin: 15 }}
                        rows={6}
                        value={BugText}
                        placeholder="Please describe the problem here..."
                        onChange={handleBugInput}
                        fullwidth
                        multiline
                    />

                    <Button id="submit_btn" variant="contained" className={classes.control_button} onClick={event => props.Bug(BugText)}>
                        SUBMIT BUG
                    </Button>
                </Container>

            </Container>
        </React.Fragment>
    )
}




//  game target circle
//
export const GameTarget = (props) => {
    const Classes = UTIL_useStyles();
    //console.log("wait.97:  props=",props);
    return (
        <div id="target0" className={Classes.game_target} style={{ "width": props.Size + 'px', "height": props.Size + 'px', "zIndex": 0 }} />
    )
}




// <LeaderBoard>  - display carousel of ranked players with avatar
//
const leader_useStyles = makeStyles(theme => ({
    leader_container: {
        display: "flex",
        flexDirection: "column",
        position: 'relative',
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        border: '0px',
        zIndex: '500',
        overflow: 'hidden',
    },
    leader_list_container: {
        display: 'flex',
        width: '100%',
        //height: '100%',       // fragile - allows inner box scroll if not show
        margin: '0',
        padding: '0px 10px',
        flexDirection: "column",
    },
    leader_header_container: {
        display: 'flex',
        flexDirection: "column",
        position: 'relative',
        width: '100%',
        height: '50px',
        margin: '0',
        padding: '0px 0px',
        overflow: 'hidden',
    },
    leader_header_row: {
        display: 'flex',
        flexDirection: "row",
        position: 'relative',
        width: '100%',
        height: '50px',
        margin: '0',
        padding: '3px 0px',
        overflow: 'hidden',
    },
    leader_body_container: {
        display: 'flex',
        flexDirection: "column",
        width: '100%',
        height: 'calc(100% - 50px)',
        //height: '100px',        // fragile - prob need to make custom <carousel>, to chg carousel-inner
        margin: '0',
        padding: '5px 10px',
        overflow: 'auto',
    },
    leader_carousel_container: {
        height: '100%',
    },
    leader_carousel_item: {
        height: '100%',
        //height: '500px',
    },
    leader_title_text: {
        fontWeight: 'bold',
        fontSize: '0.85rem',
        color: '#5d5c5c',
    },
    leader_title2_text: {
        fontWeight: 'bold',
        fontSize: '0.7rem',
        marginBottom: '3px',
    },
    leader_row_container: {
        display: 'flex',
        width: '95%',
        flexDirection: "row",
        margin: '3px 5px',
        padding: '0',
        justifyContent: 'flex-start',
        fontSize: '0.8rem',
    },
    leader_rank_text: {
        margin: '0 10px 0 10px',
        color: '#5c5c5c',
        fontSize: '0.8rem',
    },
    leader_name_text: {
        margin: '0 0 0 10px',
        fontSize: '0.8rem',
    },
    leader_value_text: {
        margin: '0 0 0 10px',
        fontSize: '0.8rem',
    },
    expand_btn: {
        position: 'relative',
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        zIndex: '300',
    },
    dash_drill_btn: {
        position: 'absolute',
        right: '0',
        top: '0',
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        //background: 'rgba(230, 230, 230, 0.99)',
        zIndex: '300',
    },

    carousel_inner: {
        background: 'red',
    }

}));


//  list the ranked player list with avatar
//
export const LeaderBoard = (props) => {
    const classes = leader_useStyles();
    const Classes = UTIL_useStyles();
    const [ Leaders, setLeaders ] = useState([]);
    const [ Players, setPlayers ] = useState([]);
    const [ CardIndex, setCardIndex ] = useState(0);
    const [ ShowDrill, setShowDrill ] = useState(false);
    //console.log("wait.97:  props=",props);

    /// UTIL: compare and find the highest level leaderboard (most members)
    //      - world: 1000
    //      - country: 900
    //      - state: 700
    //      - county: 600
    //      - msa: 5000
    //      - city: 1000
    //      - org: 800
    //      - club: 500
    //      - team: 200
    //      - program: 100
    //
    // TODO: Use member count in this calculation!  *******
    function groupPoints(hash, target_hash) {
        var key = hash.split(":")[0];
        var target = target_hash.split("+")[1];
        var val0 = 0, val1 = 0;

        switch(key) {
            case "geo":
                val0 = 5000;
                break;
            case "org":
                val0 = 1000;
                break;
            case "grp":
                val0 = 200;
                break;
            case "prg":
                val0 = 100;
                break;
            default:
                break;
        }

        switch(target) {
            case "sc0":
                val1 = 500;
                break;
            case "r00":
            case "r01":
                val1 = 400;
                break;
            case "r04":
                val1 = 100;
                break;
            default:
                break;
        }

        //console.log("grp_pt.1222:                  hash=", hash, "  pt=",val);
        return (val0 + val1);
    }


    useEffect(() => {
    }, [1]);


    useEffect(() => {
        displayDrillBtn();
    }, [CardIndex, Leaders]);


    // LEADERBOARD PROCESSING
    //
    var lconsole_log = (false) ? console.log : () => {};		// true will disable console.log
    useEffect(() => {
            var leaders = [], idx = null;
            var news = [];
            var user_key = makeUserKey(INFO.email, "Leaderboard.2313");

            if ((props.Leaders === null) || (props.Leaders === undefined) || (props.Leaders.length === 0)) {
                setLeaders(leaders);
                setShowDrill(false);
                INFO.db_news = [];
                return;
            }
            console.log("################ LEADERBOARD START   ", props.Leaders.length)

            var sleaders = JSON.parse(JSON.stringify(props.Leaders));
            sleaders.sort(arrayTargetHashAscSort);      // but was sorted already
            var has_user = sleaders.filter(m => { return m[user_key] !== undefined });
            lconsole_log("lead.1310:      XXXXXXXXXXXXX  user_key=",user_key, "  has_user= ", has_user);
            var last_target = null;
            for(var i = 0; i < sleaders.length; i++) {
                var leader = sleaders[i];
                var players = [];
                if(qualifiedBoard(leader.target_hash, leader.subtype) === false) {
                    lconsole_log("lead.399: ########",i,"##########   SKIP   .....",leader.target_hash, "  ",leader.owner_hash, " subtype=",leader.subtype, "  ",leader);
                    continue;       // skip over fields that we don't care about
                }

                if (last_target !== leader.target_hash) {
                    last_target = leader.target_hash;
                    var best_owner_hash = leader.owner_hash;
                    var best_points = 0;
                    idx = i;
                    lconsole_log("lead.2281: ########",i,"########## ",leader.target_hash, "  ",leader.owner_hash, " type=",leader.subtype);     //, "  ",leader);
                    for (var j = i; j < sleaders.length; j++) {
                        var nleader = sleaders[j];

                            //lconsole_log("lead.2238:        ...... j=",j,"  ",user_key, "   " , nleader);
                            if (nleader.target_hash == last_target) {
                                // select highest "raking" leader board that the users is IN
                                //
                                var points = groupPoints(nleader.owner_hash, nleader.target_hash);
                                nleader.point = points;
                                //if (higherLeaderBoard(best_owner_hash, nleader.owner_hash) === true) 
                                if(points > best_points) {
                                    best_owner_hash = nleader.owner_hash;
                                    best_points = points;
                                    idx = j;
                                    lconsole_log("lead.1282:      ",j,"        ++++ GOT NEW LEADERBOARD  ",nleader.target_hash, " ", nleader.owner_hash, " idx=",idx, " best_pts=",best_points);
                                } else {
                                    lconsole_log("lead.1284:      ",j,"        .... NOT BETTER           ",nleader.target_hash, " ", nleader.owner_hash, " idx=",idx," j=",j, " pts=", points, " best_pts=",best_points);
                                }
                            } else {
                                // switched to different drill
                                //
                                //lconsole_log("lead.1285:              END  ",props.Leaders[idx].owner_hash, "  idx=",idx, " j=",j, " i=",i);
                                lconsole_log("lead.2282:       ",j,"  ......... HAS NEW DRILLL ",nleader.target_hash, " ", nleader.owner_hash, " idx=",idx, " best_pts=",best_points);
                                break;
                            }
                    }

                    i = j - 1;      // skip ahead
                    //lconsole_log("lead.2287:              END  ",props.Leaders[idx].owner_hash, "  idx=",idx, " j=",j, " i=",i);
                    lconsole_log("lead.2341:              END  ",sleaders[idx].target_hash, "  ",sleaders[idx].owner_hash, "  idx=",idx, " j=",j, " i=",i);
                    lconsole_log("lead.1591:           ...PROCESS LEADER  idx=",idx, " i=",i, "  leaders=",sleaders.length, " ", sleaders[idx]);
                    //if ((i <= props.Leaders.length) && (props.Leaders[idx] !== undefined)) 
                    if ((i <= sleaders.length) && (sleaders[idx] !== undefined)) {
                        //var leader =  Object.assign({}, props.Leaders[idx]);     // copy object
                        var leader =  Object.assign({}, sleaders[idx]);     // copy object
                        leader.points = best_points;

                        lconsole_log("lead.1205:            ",idx,"  ANALYZE LEADER SCORE..... ",leader.target_hash, " ", leader.owner_hash, "  best=",best_points);
                        for (var user in leader) {
                            var bits = user.split(":");
                            if (bits.length == 2) {
                                //console.log("lead.409:                 ",leader[user]);
                                var name = leader[user].user_name;
                                if (name !== undefined) {
                                    var bits = name.split(" ");
                                    var first = capitalize(bits[0]);
                                    //console.log("1611:  user_name=",name, "  bits[1]=", bits[1]);
                                    var last = "";
                                    if ((bits.length > 1) && (bits[1].length > 0)) {
                                        last = bits[1][0].toUpperCase();
                                    }
                                    //var last = (bits[1] === undefined) ? "" : bits[1][0].toUpperCase();
                                    leader[user].user_full = first + " " + last;
                                } else {
                                    leader[user].user_full = "UNKNOWN";
                                }
                                lconsole_log("lead.2316:            ",i,"             +++ ADD PLAYER  ", leader[user].user_full, " ", leader[user]); //, "  ", leader[user]);
                                leader[user].title = leader[user].title.toUpperCase() + " OF THE DAY";
                                players.push(leader[user]);     // legit user (<name>:<doamin>)
                            }
                        }

                        // sort according type field type
                        //
                        var bits = leader.target_hash.split("+");
                        var target = bits[1];
                        if (low_target_field_type(target) === true) {
                            players.sort(arrayValueAscSort);
                        } else {
                            players.sort(arrayValueDesSort);
                        }

                        for (var p = 0; p < players.length; p++) {
                            var player = players[p];
                            player.rank = p + 1;

                            // below is for <NewsFeed> of peer player progress
                            //
                            player.owner_hash = leader.owner_hash;
                            player.target_hash = leader.target_hash;
                            player.subtype = leader.subtype;
                            player.points = leader.points;
                            player.id = getDrillID(leader.target_hash);
                            lconsole_log("lead.1323:                    .....RANK   ",player.user_full, "  rank=",player.rank);
                        }
                        news = news.concat(players);

                        // add it when this user is on it, or if the user is not on any leaderboard
                        //
                        if(qualifiedBoard(leader.target_hash, leader.subtype) === true) {
                            if ((leader[user_key] !== undefined) || (has_user.length === 0)) {
                                var board = {}
                                board.target_hash = leader.target_hash;
                                board.owner_hash = leader.owner_hash;
                                board.subtype = leader.subtype;
                                board.points = leader.points + (players.length * 10);
                                board.players = players;
                                leaders.push(board);
                                lconsole_log("lead.1310:            ",i,"      ADDING LEADERBOARD ",board.target_hash, "  ",board.owner_hash, " subtype=",leader.subtype, " points=",board.points);      //, "  ",leader);
                            }
                        } else {
                            lconsole_log("lead.1317:            ",i,"    --- SKIP ",leader.target_hash, "  ",leader.owner_hash, " subtype=",leader.subtype);     //, "  ",leader);
                        }
                    }
                }
            }

            leaders.sort(arrayPointsDesSort);
            lconsole_log("leaderbd.1714:       FINAL LEADERS ",leaders, " CardIndex=", CardIndex);
            lconsole_log("leaderbd.2352:       FINAL NEWS ",news);
            setLeaders(leaders);
            INFO.db_news = news;        // for player news, not limited to leaderboard that has this user
            window.dispatchEvent(INFO.has_news_event);    // OBSELETE?

    }, [props.Leaders]);



    function displayDrillBtn() {
        if ((Leaders === null) || (Leaders[CardIndex] === undefined)) {
            return
        }

        var leader = Leaders[CardIndex];
        var target_hash = Leaders[CardIndex].target_hash;
        var bits = target_hash.split("+");
        var target = bits[bits.length - 1];

        console.log("display_drill_btn.1816:  target=",target, " target_hash=",target_hash, " subtype=",leader.subtype);
        if(target !== "sc0") {
            setShowDrill(true);
        } else {
            setShowDrill(false);
        }

    }


    function handleDrillAction() {
        // short cut to run the drill directly from the leaderboard
        //
        var target_hash = Leaders[CardIndex].target_hash;
        console.log("leader.drill.1813:   Run Drill From Leader Board   idx==",CardIndex, "  target_hash=",target_hash);
        props.DrillAction(target_hash)
    }


    const handleCarouselSelect = (selectedIndex, e) => {

        console.log("leader_select.1821:  Leader new index=",selectedIndex);
        setCardIndex(selectedIndex);
    };

    const handleExpand = (e) => {
        console.log('ldr_expand.3361:   ....ENTER HANDLE EXPAND LEADER  ');
        props.Expand();
    };



//<Container id="custom_inner" className={classes.leader_carousel_container} ></Container>
    return (
        <React.Fragment>
            { Leaders && (Leaders.length > 0) ?

                <Container id="leaderboard" className={classes.leader_container} >

                    {ShowDrill && <Button id="top_leader_btn" className={classes.dash_drill_btn} onClick={handleDrillAction}>
                        <FontAwesomeIcon 
                            className={classes.bug_icon}
                            icon={faSun}
                            style={{ fontSize: "1.7rem"}} />
                    </Button>}

                    <Carousel id="leader_carousel_container" 
                            interval={null} 
                            indicators={null}
                            activeIndex={CardIndex} 
                            onSelect={handleCarouselSelect}
                            style= {{'height': "calc("+props.Height+"px - 30px)"}}
                            className={classes.leader_carousel_container} >

                        {Leaders && Leaders.map((leader, index1) => {
                            return(
                                <Carousel.Item id={"citem_"+index1} 
                                            key={"lead_citem_"+index1}  
                                            style= {{'height': "calc("+props.Height+"px - 30px)"}}
                                            className={classes.leader_carousel_item}>
                                  <Container key={"list_"+index1} className={classes.leader_list_container}>
                                    <Container key={"list_a_"+index1} className={classes.leader_header_container}>
                                        <Container key={"list_a1_"+index1} className={classes.leader_header_row}>
                                            <TypeIcon Type={leader.owner_hash} style={{width: "12px", height: "auto", marginRight: "5px"}} />
                                            <Typography className={classes.leader_title_text}> {getLeaderBoardTitle(leader.owner_hash)+" ("+(index1+1)+")"}  </Typography>
                                        </Container>
                                        <Container key={"list_a2_"+index1} className={classes.leader_header_row}>
                                            <TypeIcon Type={leader.subtype} style={{width: "12px", height: "auto", marginRight: "5px"}} />
                                            <Typography className={classes.leader_title2_text}>{getDrillTitle(leader.target_hash).toUpperCase()} </Typography>
                                        </Container>
                                    </Container>

                                    <Container key={"list_b_"+index1} className={classes.leader_body_container}>
                                      {leader.players && leader.players.map((card, index2) => {
                                        //console.log("card.1457:         idx1=",index1," idx2=",index2,"  card=", card);
                                        return(
                                            <React.Fragment key={"leader_crow_"+index2+card.id}>
                                                <Container key={"lead_crow_"+index2+card.id} id={"lcrow_"+index2+"_"+card.id} className={classes.leader_row_container}>
                                                    <Typography className={classes.leader_rank_text}> {"#"+(index2+1)+" "} </Typography>
                                                    <Avatar id="avatar3" Style={{height: "20px"}} Image={card.user_avatar} />
                                                    <Typography className={classes.leader_name_text}> {card.user_full} </Typography>
                                                    <Typography className={classes.leader_value_text}> {card.value} </Typography>
                                                </Container>
                                            </React.Fragment>
                                        )
                                      })}
                                    </Container>

                                  </Container>
                                </Carousel.Item>
                            )
                        }) }

                    </Carousel>

                {(props.ExpandMode === false) ? 
                    <Button id={"exapand_btn"} className={classes.expand_btn} onClick={handleExpand}>
                        <FontAwesomeIcon 
                            icon={faChevronDown}
                            style={{fontSize: "1.2rem"}} />
                    </Button>
                    :
                    <Button id={"contract_btn"} className={classes.expand_btn} onClick={handleExpand}>
                        <FontAwesomeIcon 
                            icon={faChevronUp}
                            style={{fontSize: "1.2rem"}} />
                    </Button>
                }
              </Container>

              :

                <React.Fragment>
                    <Container key={"list_wait"} className={classes.leader_list_container}>
                      <Container key={"list_a_wait"} className={classes.leader_header_container}>
                        <Container key={"list_a1_wait"} className={classes.leader_header_row}>
                            <Typography className={classes.leader_title_text}> LEADERBOARD</Typography>
                        </Container>
                      </Container>
                    </Container>

                    <div role="status" style={{ display: "flex", 
                                              alignItems: "center",
                                              justifyContent: "center",
                                              height: "100%", }}> 
                        <LoadingBars color="#ccc" size="0.5em" /> 
                    </div>
                </React.Fragment>
            }

        </React.Fragment>
    )
}





//  list the bar graph scores 
//
const scores_useStyles = makeStyles(theme => ({
    scores_container: {
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        border: '0px',
        zIndex: '500',
    },
    scores_list_container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        margin: '0',
        //padding: '0',
        padding: '5px 10px',
        flexDirection: "column",
    },
    scores_carousel_container: {
        height: '100%',
        overflow: 'hidden',
        padding: '0',
        margin: '0',
    },
    scores_carousel_item: {
        height: '100%',
        padding: '0',
        margin: '0',
    },
    scores_title_text: {
        fontWeight: 'bold',
        fontSize: '0.85rem',
        color: '#5d5c5c',
    },

}));

export const DailyScore = (props) => {
    const classes = scores_useStyles();
    const Classes = UTIL_useStyles();
    const [ Scores, setScores ] = useState(null);
    const [ ScoreTitle, setScoreTitle ] = useState(null);
    const [CardIndex, setCardIndex] = useState(0);
    const [Refresh, setRefresh] = useState(0);

    /// UTIL: sort array based on sequence
    function arrayValueDesSort(a, b) {
        if (a.value == b.value) {
            return 0;
        }
        else {
            return (a.value > b.value) ? -1 : 1;
        }
    }

    useEffect(() => {
            if ((props.Scores === null) || (props.Scores === undefined) || (props.Scores.length === 0)) {
                setScores([]);
                setCardIndex(0);
                setRefresh(Date.now());
                return;
            }
            console.log("################ DAILY SCORE START   DATA=", props.Scores.length)

            for(var i = 0; i < props.Scores.length; i++) {
                var score = props.Scores[i];
                //console.log("score.1374:     ",i," DAYS   SCORE..... ",score.title, " ", score.data);
            }

            setScores(props.Scores);
            setCardIndex(0);
            setRefresh(Date.now());
    }, [props.Scores]);


    useEffect(() => {
        //console.log("score.1375:  props.Scores=",props.Scores, " CardIndex=",CardIndex);
        if ((props.Scores === undefined) || (props.Scores[CardIndex] === undefined)) return;

        var title0 = props.Scores[CardIndex].title;
        var title = "ALL TIME"
        switch(title0) {
            case -7:
                title = "LAST WEEK"
                break;
            case 7:
                title = "THIS WEEK"
                break;
            case 14:
                title = "TWO WEEK"
                break;
            case 28:
                title = "ONE MONTH"
                break;
            default:
                break;
        }

        GATag("Dashboard", "Score.Show", title, 0);		 // (cat, act, lab, val)
        //console.log("score.1980:  Set Score Title=",title);
        setScoreTitle(title+" SCORES");
    }, [CardIndex, Refresh]);


    const handleScoreSelect = (index, e) => {
        console.log("score.1986:  Score new index=",index);
        setCardIndex(index);
    };


                            //<Typography className={classes.scores_title_text}> {index1+": "+score.title} </Typography>
                        //indicators={null}
    return (
        <React.Fragment>
            <Container id="scores_bargraph" className={classes.scores_container} >

                    <Carousel id="scores_carousel_container" 
                        interval={null} 
                        indicators={null}
                        activeIndex={CardIndex} 
                        onSelect={handleScoreSelect}
                        style= {{'height': props.Height }}
                        className={classes.scores_carousel_container} >

                        {Scores && Scores.map((score, index1) => {
                            return(
                                <Carousel.Item  key={"score_carou_item_"+index1} 
                                        style= {{'height': props.Height }}
                                        className={classes.scores_carousel_item}>
                                    <Container className={classes.scores_list_container}>
                                        <Typography className={classes.scores_title_text}> {ScoreTitle} </Typography>
                                        <BarGraph key={"data_"+index1} Data={score.data} />
                                    </Container>
                                </Carousel.Item>
                            )
                        }) }

                    </Carousel>

            </Container>
        </React.Fragment>
    )
}




// <NewsFeed>  - display ranked players with avatar
//      - search thru leaderboards, extract out related players (de-dupe by drill-player)
//
const news_useStyles = makeStyles(theme => ({
    xxx_news_container: {
        display: 'flex',
        position: 'absolute',
        width: '50vw',
        height: '40vh',
        minHeight: '280px',
        minWidth: '300px',
        margin: '0',
        marginTop: '10vh',
        padding: '0',
        justifySelf: 'center',
        alignSelf: 'center',
        border: '0px',
        borderRadius: '8px',
        boxShadow: 'rgba(50, 50, 93, 0.55) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        backgroundColor: 'rgba(230, 230, 230, 0.99)',        // Dark Cornflower Blue  (20, 70, 162, 0.95)',
        zIndex: '500',
    },
    news_container: {
        display: 'flex',
        flexDirection: "column",
        position: 'relative',
        width: '100%',
        height: '100%',
        margin: '0',
        padding: '0',
        border: '0px',
        zIndex: '500',
        overflow: 'hidden',
    },
    news_body_container: {
        height: '100%',
        overflow: 'auto',
        margin: '0',
        padding: '0',
    },
    leader_list_container: {
        display: 'flex',
        width: '100%',
        //height: '100%',       // fragile - allows inner box scroll if not show
        margin: '0',
        padding: '0px 10px',
        flexDirection: "column",
    },
    leader_title_text: {
        fontWeight: 'bold',
        fontSize: '0.85rem',
        color: '#5d5c5c',
    },

    leader_header_container: {
        display: 'flex',
        flexDirection: "column",
        position: 'relative',
        width: '100%',
        margin: '0',
        padding: '0px 15px',
        overflow: 'hidden',
    },

    leader_header_row: {
        display: 'flex',
        flexDirection: "row",
        position: 'relative',
        width: '100%',
        //height: '50px',
        margin: '0',
        padding: '3px 0px',
        overflow: 'hidden',
    },
    news_body_text: {
        width: '100%',
        height: 'auto',
        margin: '0 0 0 10px',
        padding: '0',
        //padding: '5px 0px',
        flexDirection: "column",
    },

    news_btext1: {
        fontWeight: 'bold',
        width: '100%',
        margin: '0',
        padding: '0',
		fontSize: '0.7rem',
        color: '#12101d',
        flexDirection: "row",
    },

    news_btext2: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        width: '100%',
        margin: '0',
        padding: '0',
		fontSize: '0.7rem',
        color: '#767782',
    },
    card_value: {
        fontWeight: 'bold',
        fontSize: '0.8rem',
        color: '#5d5c5c',
        width: 'auto',
        padding: '0 8px 0 0',
        margin: '0',
    },
    drill_value: {
        fontSize: '0.7rem',
        color: '#5d5c5c',
        width: 'auto',
        padding: '0',
        margin: '0',
        alignSelf: 'center',
    },
    dash_drill_btn: {
        position: 'absolute',
        right: '0',
        top: 'cals(100% - 38px)',
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        zIndex: '300',
    },
    expand_btn: {
        position: 'relative',
        color:'#5d6a9f',
        alignSelf: "center",
        margin: '0px',
        padding: '0px',
        borderRadius: '50%',
        padding: '3px',
        minWidth: '20px',
        width: '35px',
        zIndex: '300',
    },

    card_title_text: {
        width: '100%',
        margin: '0',
		fontSize: '0.9rem',
    },
}));


//  list recent news, like new records from friends
//      - extract alll leaders from all boards
//      - de-dupe by drill & player
//      - sort by recency
//      - display each in a card, with video
//
export const NewsFeed = (props) => {
    const classes = news_useStyles();
    const Classes = UTIL_useStyles();
    const [ News, setNews ] = useState([]);
    const [ Cards, setCards ] = useState([]);
    const [ Title, setTitle ] = useState("");
    const { State, Dispatch } = useContext(appContext);

    useEffect(() => {
    }, [1]);

    /// UTIL: sort array based on sequence
    function arraySourceTimestampDesSort(a, b) {
        var field = "source_timestamp"
        if (a[field] == b[field]) {
            return 0;
        }
        else {
            return (a[field] > b[field]) ? -1 : 1;
        }
    }

    /// UTIL: sort array based on sequence
    function arrayOwnerHashAscSort(a, b) {
        var field = "owner_hash"
        if (a[field] == b[field]) {
            return 0;
        }
        else {
            return (a[field] < b[field]) ? -1 : 1;
        }
    }


    var nconsole_log = (false) ? console.log : () => {};		// true will enable console.log
    useEffect(() => {
            var players = [];
            var leaders = INFO.db_news;
            if ((leaders === null) || (leaders === undefined) || (leaders.length === 0)) {
                setCards([]);
                setTitle("");
                return;
            }
            console.log("################ NEWSFEED START   ", leaders.length)
            setTitle("PLAYER NEWS");

            // find only scores so we can figure out the avearege
            //
            var sleaders = leaders.filter(m => { return m.subtype == "_none_" });
            sleaders.sort(arrayOwnerHashAscSort);       // go by the heirarchy
            var last_owner = (sleaders[0] === undefined) ? "" : sleaders[0].owner_hash;
            var sum = 0, avg = 0, cnt = 0, start = 0, end = 0;
            for(var i = 0; i < sleaders.length; i++) {
                var sleader = sleaders[i];
                // go through all scores and hide the "untouchable" socres (don't rub it in)
                //
                nconsole_log("news.2817:    FILTER      ",i,"  owner_hash=",sleader.owner_hash, " last_owner=",last_owner, " start=",start, "  end=",end, "  sum=",sum);
                if ((sleader.owner_hash !== last_owner) || (i == sleaders.length - 1)) {
                    nconsole_log("news.2817:          DIFF   ",i,"  owner_hash=",sleader.owner_hash);
                    avg = sum / cnt;
                    for (var j = start; j < end; j++) {
                        var player0 = sleaders[j];
                        nconsole_log("news.2821:          FILTER  ",j,"  .....avg=",Math.floor(avg), "  sum=",Math.floor(sum), " start=",start, " end=",end);
                        if ((player0.value < (avg * CONSTS.MAX_HIGH_SCORE_MULTIPLE)) && (player0.rank !== undefined)) {
                            nconsole_log("news.2823:           +++ SCORE.VALID    ",player0.target_hash, " ",player0.user_key, " ",player0.owner_hash, "  value=",player0.value, " point=",player0.point, " rank=",player0.rank, " ",player0.source_timestamp);
                            sleaders[j].valid = true;
                        } else {
                            sleaders[j].valid = false;
                        }
                    }
                    sum = 0;
                    cnt = 0;
                    start = i;
                    last_owner = sleader.owner_hash;
                } else {
                    nconsole_log("news.2817:          SAME   ",i,"  owner_hash=",sleader.owner_hash);
                    sum = sum + sleader.value;
                    cnt = cnt + 1;
                    end = i;
                }
            }

            for(var i = 0; i < leaders.length; i++) {
                var leader = leaders[i];
                if(qualifiedBoard(leader.target_hash, leader.subtype) === true) {

                    if ((leader.subtype === "_none_") && (leader.valid === false)) {
                        // do not update "untouchable" scores in player news
                        nconsole_log("news.2870:            .....SKIP  ",leader.target_hash, " ",leader.user_id, " ",leader.owner_hash, "  value=",leader.value, " point=",leader.point, " rank=",leader.rank, " ",leader.source_timestamp);
                    } else {
                        //nconsole_log("news.2750:            USER       ",user, "   ", out0.value, "  rank=",out0.rank);
                        if (leader.rank !== undefined) {
                            nconsole_log("news.2750:            .....INIT  ",leader.target_hash, " ",leader.user_id, " ",leader.owner_hash, "  value=",leader.value, " point=",leader.point, " rank=",leader.rank, " ",leader.source_timestamp, " ", leader.video);
                            players.push(leader);     // legit user (<name>:<doamin>)
                        }
                    }
                }
            }


            players.sort(arraySourceTimestampDesSort);        // more recent first
            for (var p = 0; p < players.length; p++){
                var out = players[p];
                nconsole_log("news.2716:  ==== FINAL ",out.target_hash, " ",out.user_id, " ",out.owner_hash, "  value=",out.value, " point=",out.points, " rank=",out.rank, " ",out.source_timestamp);
            }
            setCards(players);

    }, [ props.Leaders ]);

    function displayDrillBtn(target_hash) {
        //var leader = Leaders[CardIndex];
        //var target_hash = Leaders[CardIndex].target_hash;

        if ((target_hash === null) || (target_hash === undefined)) { return }
        var bits = target_hash.split("+");
        var target = bits[bits.length - 1];

        //console.log("display_drill_btn.1816:  target=",target, " target_hash=",target_hash);
        if(target !== "sc0") {
            return(true);
        } else {
            return(false);
        }

    }

    const handleDrillAction = (target_hash) => (event) => {
        // short cut to run the drill directly from the leaderboard
        //
        //var target_hash = Leaders[CardIndex].target_hash;
        //console.log("leader.drill.2924:   Run Drill From Leader Board   idx==",CardIndex, "  target_hash=",target_hash);
        props.DrillAction(target_hash)
    }

    const handleExpand = (e) => {
        console.log('new_expand.2976:   ....ENTER HANDLE EXPAND NEWS  ');
        props.Expand();
    };


                    /*
                    <Button id="top_leader_btn" className={classes.dash_drill_btn} onClick={handleDrillAction}>
                        <FontAwesomeIcon 
                            className={classes.bug_icon}
                            icon={faSun}
                            style={{ fontSize: "1.7rem"}} />
                    </Button>
                        <TypeIcon Type={card.subtype} style={{width: "20px", height: "auto", marginRight: "8px"}} />
                    */

    // news feed
    return (
        <React.Fragment>
            <Container id="newsfeed" className={classes.news_container} >

                <Container key={"news_head0"} className={classes.leader_header_container}>
                    <Container key={"news_head1"} className={classes.leader_header_row}>
                        <Typography className={classes.leader_title_text}> {Title} </Typography>
                    </Container>
                </Container>

                <Container key={"news_body"} className={classes.news_body_container}
                        style= {{'height': "calc("+props.Height+"px - 30px)"}}>
                    
                  {(Cards && Cards.length > 0) ?
                    Cards.map((card, index1) => {
                        return(
                                <Container key={"list_"+index1} className={classes.leader_list_container}>
                                    <Container key={"list_a1_"+index1} className={classes.leader_header_row}>
                                        <Avatar id={"avatar4"+index1} Style={{height: "25px"}} Image={card.user_avatar} />

                                        <Container key={"list_txt1_"+index1} className={classes.news_body_text}>
                                            <Container key={"list_txt2_"+index1} className={classes.news_btext1}>
                                                {card.user_full+ " Ranks #"+card.rank + " " + getLeaderBoardTitle(card.owner_hash, true)}  
                                            </Container>
                                            <Container key={"list_txt3_"+index1} className={classes.news_btext2}>
                                                <Container key={"list_txt4_"+index1} className={classes.card_value}>
                                                    {parseInt(card.value)}
                                                </Container>
                                                <Container key={"list_txt5_"+index1} className={classes.drill_value}>
                                                    {getDrillTitle(card.target_hash).toUpperCase()}
                                                </Container>
                                            </Container>
                                        </Container>

                                        {displayDrillBtn(card.target_hash) && <Button id={"btn_"+index1} className={classes.dash_drill_btn} onClick={handleDrillAction(card.target_hash)}>
                                            <FontAwesomeIcon 
                                                className={classes.bug_icon}
                                                icon={faSun}
                                                style={{ fontSize: "1.7rem"}} />
                                        </Button>}

                                    </Container>
                                </Container>
                            )
                    })

                  :
                    <React.Fragment>
                          <Container key={"list_a_wait"} className={classes.leader_header_container}>
                            <Container key={"list_a1_wait"} className={classes.leader_header_row}>
                                <Typography className={classes.leader_title_text}> PLAYER NEWS </Typography>
                            </Container>
                          </Container>

                        <div role="status" style={{ display: "flex", 
                                              alignItems: "center",
                                              justifyContent: "center",
                                              height: "100%", }}> 
                            <LoadingBars color="#ccc" size="0.5em" /> 
                        </div>
                    </React.Fragment>
                  }

                </Container>

                {(props.ExpandMode === false) ? 
                    <Button id={"exapand_btn"} className={classes.expand_btn} onClick={handleExpand}>
                        <FontAwesomeIcon 
                            icon={faChevronDown}
                            style={{fontSize: "1.2rem"}} />
                    </Button>
                    :
                    <Button id={"contract_btn"} className={classes.expand_btn} onClick={handleExpand}>
                        <FontAwesomeIcon 
                            icon={faChevronUp}
                            style={{fontSize: "1.2rem"}} />
                    </Button>
                }

            </Container>
        </React.Fragment>)
}



//  individual card in the news feed
//      - new player record highs
//      - event displacing owner from leaderboard
//
export const NewsCard = (props) => {
    const classes = news_useStyles();
    const Classes = UTIL_useStyles();
    const [ BugText, setBugText ] = useState("");

    useEffect(() => {
    }, [1]);


    return (
        <React.Fragment>
            <Container id="news_card" className={classes.cards_container} >

            </Container>
        </React.Fragment>
    )

}




// <ShowCatalogItem>  - show drill icons
//
const item_useStyles = makeStyles(theme => ({
    item_container: {
        display: "flex",      // not needed at item level
        position: 'relative',

        flexDirection: "row",
        flexWrap: 'wrap',
        justifyItems: "space-between",
        justifyContent: "space-between",
        alignItems: "flex-start",

        height: "100px",
        width: "20vw",      // 22vw, 20vw
        maxWidth: "200px",
        minWidth: "150px",      //"135px",  140px, 120px
        //padding: '20px',
        margin: "10px",
        padding: '0px 0px 0px 0px',     // 8px

        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '6px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 5px 10px -3px',
        backgroundColor: 'rgba(71,95,130,0.6)',
        overflow: 'hidden',
        zIndex: '310',              // catalog overlay

        //width: "180px",
    },
    item_text: {
        flexDirection: "row",
        padding: '0',
        margin: '0',
        color: "white",
        fontSize: '0.9rem',
        textAlign: 'center',
        overflow: 'hidden',
        zIndex: '100',
        height: '25%',
        //backgroundColor: 'red',
        //flexWrap: 'wrap',
        //borderRadius: '6px 6px 0px 0px',
    },
    catalog_icon_body: {
        position: 'absolute',
        bottom: '3px',      // 4px
        left: '3px',        // 4px
        width: '40px',      //'auto',
        height: 'auto',
        margin: '0',
        padding: '0',
        color: '#28475369',
        //padding: '0 0 5px 5px',
    },
    thumbnail: {
        position: 'absolute',
        top: '25%',
        left: '0',
        width: '100%',       // 78%
        height: '75%',
        margin: '0',
        padding: '0 0 0px 0px',
        zIndex: '0',
    }

}));

export const ShowCatalogItems = (props) => {
    const classes = item_useStyles();
    const Classes = UTIL_useStyles();
    const [ TabValue, setTabValue ] = useState(0);
    const [ Items, setItems ] = useState([]);
    const LEVEL_COLOR = ["#0f833d61","#1a9c629e", "#07953fd1", "#04ab46f2", "#443b936e", "#2b2fa394"]
    const LEVEL_BACKGROUND_COLOR = ["#0f833d60","#12a54c60", "#07953f60", "#04ab4660", "#443b9360", "#2b2fa360"]
    //const LEVEL_BACKGROUND_COLOR = ["#0f833d31","#12a54c6e", "#07953fa1", "#04ab46d2", "#443b933e", "#2b2fa364"]
    //var Items = props.Items;

    useEffect(() => {
        console.log("show_cat_item.2309:  ###### START Catalog_Entry  props.TabValue=", props.TabValue, " props.Items=", props.Items);
    }, [1] );

    useEffect(() => {
        console.log("show_cat_item.3203:  . . . . . . . Catalog_Entry  props.TabValue=", props.TabValue, " props.Items=", props.Items);
        setItems(props.Items)
    }, [props.Items] );

    useEffect(() => {
        //console.log("Catalog.62:   Display Refresh  ", props.Items);
        console.log("show_cat_item.3213:   . . . . . . .  CATALOG ITEM REFRESH   props.TabValue=",props.TabValue, "  props.Groups=",props.Groups);
    }, [props.TabValue, props.Groups, props.Type]);


    //console.log("Catalog.126:  ******* props.Items=", props.Items.length, "  props.Groups=",props.Groups.length, "  tabvalue=",TabValue);
    //<Container key={"item_"+index} className={classes.item_container} onClick={props.Select(item)} ></Container>
    if ((props.Items === undefined) || (props.Items === null) || (props.Groups === undefined) || (props.Groups.length === 0)) {
        return "";
    }

    const handleCatalogItemSelect = item => event => {
        //console.log("catalog.211: ----->  REACHED HANDLE_ITEM_SELECT tab=", TabValue, " item=", item);
        props.Select(props.TabValue, item, "catalog.select.3555");
    }


    return (
        <React.Fragment>
            {Items && Items.map( (item, index) => {
                var hash = null;
                if(props.Groups[props.TabValue] !== undefined) {
                    hash = props.Groups[props.TabValue].hash;
                }
                //console.log("catalog.2735:        . . . . showing  ",item.name, "  key=",item.drill_key,"  type=",item.type, " item=",item);
                return (
                    (item.section_hash == hash) ?
                        <Container key={"item_"+index} className={classes.item_container} onClick={handleCatalogItemSelect(item)} >
                            <Container className={classes.item_text}  style={{background: LEVEL_COLOR[item.level - 1]}}> 
                                {item.name} 
                            </Container>

                            <img id="drill_thumb" src={CONSTS.PREVIEW_ASSET_PATH+item.drill_key} className={classes.thumbnail} />

                            <Count key={'cnt_'+index} Level={item.level} Min={item.min_sets} Background={LEVEL_BACKGROUND_COLOR[item.level - 1]}
                                   Today={item.today_cnt} Cum={item.cur_sets} Total={item.tot_sets} Name={item.name}/>
                            <Container className={classes.catalog_icon_body} >
                                <TypeIcon Type={item.type} From={"catalog"} style={{color: "#b3b4b573"}} />
                            </Container>

                        </Container>
                        :
                        ""
                )}
            )}
        </React.Fragment>
    )
}



// display icon of the data type
//
// NOTE: props.style if ****LOWER CASE S **** to match <FontAwesom>
//
export const TypeIcon = (props) => {
    const classes = item_useStyles();
    const Classes = UTIL_useStyles();
    const [ Type, setType ] = useState(null);

    useEffect(() => {
        //"org:usa:orinda:magic"
        var out = null;
        if ((props.Type !== null) && (props.Type !== undefined) && (typeof(props.Type) === "string")) {
            var bits = props.Type.split(":")
            if(bits.length > 1) {
                switch(bits[0]) {
                    case "grp":
                        out = "group";
                        break;
                    case "org":
                        out = "org";
                        break;
                    case "prg":
                        out = "program";
                        break;
                    case "usr":
                        out = "friends";
                        break;
                    case "geo":
                        out = "geo";
                        break;
                }
                //console.log("type_icon.2786:  p.type=",props.Type, "  type=", out, "  from=",props.From)
                setType(out);
            } else {
                //console.log("type_icon.2788:  type=",props.Type, "  from=",props.From)
                setType(props.Type);
            }
        }

    }, [props.Type] );


    return (
        <React.Fragment>
            {(Type === "geo") && <FaGlobe {...props} />}

            {(Type === "today") && <FaSun {...props} />}
            {(Type === "analyze") && <FaAnalytics {...props} />}
            {(Type === "admin") && <FaToolbox {...props} />}

            {(Type === "perf") && <FaStopWatch {...props} />}
            {(Type === "performance") && <FaStopWatch {...props} />}
            {(Type === "challenge") && <FaStopWatch {...props} />}

            {(Type === "skill") && <FaBullsEye {...props} />}
            {(Type === "practice") && <FaBullsEye {...props} />}
            {(Type === "mock") && <FaRunner {...props} />}

            {(Type === "game") && <FaHandPointer {...props} />}
            {(Type === "agility") && <FaHandPointer {...props} />}
            {(Type === "condition") && <FaDumbbell {...props} />}

            {(Type === "_none_") && <FaMedal {...props} />}
        </React.Fragment>
    )
}








// user avatar icon
//
const avatar_useStyles = makeStyles({
    user_avatar: {
        height: '40px',
        borderRadius: "50%",
        top: '0px',
        bottom: '0px',
        alignSelf: 'center',
        boxShadow: 'rgba(50, 50, 93, 0.95) 0px 6px 12px -2px, rgba(0, 0, 0, 0.4) 0px 3px 7px -3px',
    },
});

export const Avatar = (props) => {
    const classes = avatar_useStyles();
    const [ Image, setImage ] = useState(null);

    useEffect(() => {
      let image = (props.Image) ? props.Image : INFO.anon_avatar
      //if(!props.Image) console.log("3730.avatar:            image=",props)
      setImage(image)
    }, [props.Image]);

    return (
        <React.Fragment>
            <img src={Image}
                alt="user"
                style={props.Style}
                className={classes.user_avatar} />
        </React.Fragment>
    )
}


// countdown dialog
//
const countdown_useStyles = makeStyles({
    countdown_container: {
        position: 'absolute',
        top: '0',
        right: '0',
        height: '100%',
        width: '100%',
        maxWidth: '100%',
        justifyItem: 'center',
        alignItem: 'center',
        padding: '0% 0 0 0',
        //background: '#e1eaf5',
        background: '#3a3a40',
        zIndex: '600',
    },
    rank1_container: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        height: 'calc(80% - 65px)',     // make sure there is space on small screens
        width: '75%',
        maxWidth: '100%',
        minWidth: '500px',
        justifyItem: 'center',
        margin: '30px auto 30px 140px',      //'30px auto',
        //background: 'yellow',
    },
    rank_text: {
        width: '40%',
        fontSize: '2.2rem',
        color: 'red',
        textAlign: 'left',
        margin: '5px 0',
    },
    countdown_text: {
        fontSize: '3rem',
        textAlign: 'center',
        margin: '0 auto',
        fontWeight: 'bolder',
        color: 'red',
    },
    no_scroll_list: {
        width: '100%',
        height: '100%',
        padding: '0',
        margin: '0',
    },
    easter_container: {
        position: 'absolute',
        bottom: '0px',
        width: '8vw',
        height: '8vh',
        zIndex: '1000',
        backgroundColor: '#302e2e8c',
    },
    slave_title_text: {
        width: '100%',
        fontSize: '1.6rem',
        textAlign: 'left',
        margin: '20px 0 5px 0',        //'5px 0',
        minWidth: '350px',
        fontWeight: 'bolder',
        color: 'yellow',
    },
    logo1: {
        width: '100px',
        height: '100px',
        margin: '20px',
        zIndex: '0',
        position: 'absolute',
    },
    grid_row: {
        alignContent: "center",
        flexWrap: 'nowrap',
    },
    grid_left_text: {
        alignSelf: "left",
    },
    grid_center_text: {
        alignSelf: "center",
    },

});

const ROW_PIX = 58;

export const ScrollList = (props) => {
    const classes = countdown_useStyles();
    const aclasses = marquee_styles;
    const [ List, setList ] = useState([]);
    const [ ScrollClass, setScrollClass ] = useState(null);
    const [ MaxHeight, setMaxHeight ] = useState(null);

    useEffect(() => {

        return function cleanup() {
        }
    }, [1]);


    useEffect(() => {
    }, [List]);


    useEffect(() => {
        var sclass = null;
        var base1 = document.getElementById("scroll_"+props.ID);
        var ht = base1.clientHeight;        // Note: <div> can NOT have "height = auto"!!!

        var list = (props.List) ? props.List : [];
        setList(list)

        /* TESTING CODE
        var list = [];
        for (var i = 0; i < 20; i++) {list.push((i+1)+": BIG LIST")}
        setList(list); */

        var max_ht = list.length * ROW_PIX;
        var raw_ratio = parseInt(ht / max_ht * 100);        // Note: big list needs to be the denominator
        var ratio = ((100 - raw_ratio));
        console.log("scroll_list.3808:       # # # # # # #  SCROLL INIT    List.len=",list.length, "  ht=",ht, " max_ht=",max_ht, " raw_ratio=",raw_ratio, " ratio=",ratio);     //, " base=",base1);

        if (ratio < 0) {
            sclass =  classes.no_scroll_list;
        } else if (ratio < 10) {
            sclass =  aclasses.scroll_list10;
        } else if (ratio < 20) {
            sclass =  aclasses.scroll_list20;
        } else if (ratio < 30) {
            sclass =  aclasses.scroll_list30;
        } else if (ratio < 40) {
            sclass =  aclasses.scroll_list40;
        } else if (ratio < 50) {
            sclass =  aclasses.scroll_list50;
        } else if (ratio < 60) {
            sclass =  aclasses.scroll_list60;
        } else if (ratio < 70) {
            sclass =  aclasses.scroll_list70;
        } else if (ratio < 80) {
            sclass =  aclasses.scroll_list80;
        } else {
            sclass =  aclasses.scroll_list100;
        }

        //sclass =  aclasses.scroll_list0;      // TESTING CODE
        setScrollClass(sclass);
        setMaxHeight(max_ht);

    }, [props.TextStyle, props.List]);


                            //<Typography key={"rank"+index} className={classes.slave_rank_text} ></Typography>
                            //className={(List.length > 5) ? aclasses.scroll_list : classes.no_scroll_list}  
    return (
        <React.Fragment>
                <Container id={"scroll_"+props.ID} style={{padding: '0', height: '100%', overflow: 'clip'}}>
                    <Container className={ScrollClass} style={{padding: '0', height: (MaxHeight) + "px"}}>
                        {(props.Mode === "list") ?
                            List.map((text, index) => {
                                return(
                                <Typography key={"rank"+index} className={props.TextStyle} >
                                    {text}
                                </Typography>
                                )
                            })
                        :
                            List.map((rank, index) => {
                                return(
                                <Grid container key={"grid"+index} className={classes.grid_row}>
                                    <Grid item xs={1} key={"rank"+index} className={props.TextStyle} style={{alignSelf: 'right'}}>
                                        {rank.rank+"."}
                                    </Grid>
                                    <Grid item xs={7} key={"name"+index} className={props.TextStyle} style={{alignSelf: 'left'}}>
                                        {rank.name}
                                    </Grid>
                                    <Grid item xs={4} key={"perf"+index} className={props.TextStyle} style={{alignSelf: 'left'}}>
                                        {rank.perf}
                                    </Grid>
                                </Grid>
                                )
                            })
                        }
                    </Container>
                </Container>
        </React.Fragment>
    )
}


export const Countdown = (props) => {
    const classes = countdown_useStyles();
    const [ Timer, setTimer ] = useState(null);
    const [ Delay, setDelay ] = useState(props.Delay);
    const [ Msg, setMsg ] = useState("");
    const [ Title, setTitle ] = useState("");
    const [ Background, setBackground ] = useState(null);                 // poly: active list being displayed
    const [ Refresh, setRefresh ] = useState(null);
    //console.log("avatar.193:  img=",props.Image);

    useEffect(() => {

        setBackground(props.Background);
        INFO.countdown_time = null;
        return function cleanup() {
            INFO.countdown_time = -1;
            console.log("count.3731:  - - - - - - EXIT COUNTODWN   Delay=",props.Delay, " now=",Date.now()%100000 / 1000);
            if (Timer !== null) { 
                clearTimeout(Timer);      // get rid of old one
            }
        }
    }, [1]);


    useEffect(() => {
        //console.log("count.3741:  # # # # # # REACHED COUNTODWN   Delay=",props.Delay, " countdown_time=", INFO.countdown_time, " now=",Date.now() / 1000)
        if ((props.Delay > 0) && (INFO.countdown_time === null)) {
            INFO.countdown_time = props.Delay;
            console.log("count.3682:  # # # # # # EFFECT: START COUNTODWN Delay=",props.Delay, " now=",Date.now()%100000 / 1000)
            //var timer = setTimeout(updateTime.bind(this), 1000);
            //setTimer(timer);
            //updateTime.bind(this);
            //updateTime();
            updateCountdown(props.Delay);
            setDelay(props.Delay);
        }
    }, [props.Delay]);


    useEffect(() => {
        var msg = null;
        var name = (props.Name) ? props.Name.toUpperCase() : "";
        var ndelay = INFO.countdown_time;
        if (!props.Msg) {
            msg = name + " - REST FOR "+ndelay+" SECONDS"
        } else {
            msg = props.Msg;        // override
        }
        setMsg(msg);
        //console.log("count.3752:        REFRESH . . . msg=",msg, " Msg=",props.Msg, " Name=",props.Name, " Delay=",Delay, " ndelay=",ndelay, " now=",Date.now()%100000 / 1000);
    }, [props.Msg, props.Name, Delay]);



    useEffect(() => {
        //console.log("count.3771:        . . . DELAY REFRESH   Delay=",Delay, " Refresh=",Refresh, " Msg=",Msg);
    }, [Delay, Msg, Title, Refresh]);


    useEffect(() => {
        if (typeof(props.Title) == "string") {
            setTitle(props.Title.toUpperCase());
        }
    }, [props.Title]); 


    // Note: Race condition, the old <Countdown> wait for second to expire, exits and another one starts
    //
    const updateCountdown = async (count) => {

        for (var i = 0; i < count; i++)  {
            //console.log("count.3749:         . . . .  COUNT DOWN0   i=",i);
            var timer = await sleep(1000);
            if (Delay && (INFO.countdown_time > 0)) {
                console.log("count.3785:      . . . .  TIMER WAKEUP  cntdown_time=",INFO.countdown_time, " count=",count," now=",Date.now()%100000 / 1000);
                INFO.countdown_time = INFO.countdown_time - 1;
                setDelay(INFO.countdown_time);
                setRefresh(Date.now());
            }
        }

        if (INFO.countdown_time === 0) {
            INFO.countdown_time = null;     // set up for next call
        }
    }

    const handleEasterEgg = () => {
        props.Dismiss();
    }

                        /*
                        {props.List && props.List.map((text, index) => {
                            return(
                            <Typography key={"txt_"+index} className={classes.rank_text} >
                                {text}
                            </Typography>
                            )
                        })}
                        */

    return (
        <React.Fragment>
            {(props.Delay > 0) &&<Container className={classes.countdown_container} >
                <img id="logo" src={CONSTS.LOGO_ASSET_PATH+Background} className={classes.logo1} />
                {(Delay > 0) && 
                <React.Fragment>
                    <Container className={classes.rank1_container} >
                        <Typography className={classes.slave_title_text} >{Title}</Typography>
                        <ScrollList Mode="rank" List={props.List} TextStyle={props.TextStyle} ID={"count"} />
                    </Container>

                    <p className={classes.countdown_text} >
                        {Msg}
                    </p>
                </React.Fragment>}
                <div key="easter3_btn" id="easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleEasterEgg}/>
            </Container>}
        </React.Fragment>
    )
}



// spacer
//
const spacer_useStyles = makeStyles({
    spacer: {
        height: '40px',
        alignSelf: 'start',
    },
});

export const Spacer = (props) => {
    const classes = spacer_useStyles();
    //console.log("avatar.193:  img=",props.Image);
    return (
        <React.Fragment>
            <Container style={{width: props.Width, height: props.Height}} className={classes.spacer} >
                <p></p>
            </Container>
        </React.Fragment>
    )
}


// catalog item count
//
const count_useStyles = makeStyles(theme => ({
    count_text: {
        display: 'block',
        position: 'absolute',
        width: 'auto',
        minWidth: '35px',
        bottom: '0px',
        right: '0px',      // 10px
        textAlign: 'center',

        padding: '0 8px',
        margin: '0',
        color: '#c0e4e7',
		fontSize: '1.0rem',
        fontWeight: 'bold',
        borderRadius: '8px',
        backgroundColor: '#7d7c7c7a',
    },
}));


// CSS.absolute: https://css-tricks.com/absolute-positioning-inside-relative-positioning/
export const Count = (props) => {
    const classes = count_useStyles();
    const [ Count, setCount ] = useState(" ");
    const [ Color, setColor ] = useState(" ");
    const [ Background, setBackground ] = useState("#7d7c7c7a");

    useEffect(() => {
        setCount(null);
    }, [1]);

    // generic routine to return a number, even if it's a string or undefined
    function getNumber(val) {
        var out;
        if (typeof(val) == "string") {
            if(val.trim() == "") {
                out = 0;
            } else {
                out = parseInt(val.trim());
            }
            //console.log("conv.957:             val=", val.trim(), "  out=",out);
        } else if (typeof(val) == "number") {
            out = val;
        } else {
            out = 0;
        }
        return out;
    }

    useEffect(() => {
        var count = 0, tcount = 0;
        //console.log("count.954:   . . . COUNT  p.curr=",props.Current, " p.curr.type=",typeof(props.Current),"  p.tot=",props.Total);
        var tot = getNumber(props.Total);       // total cum for this sequence
        var curr = getNumber(props.Cum);    // current cum, do not display this tho
        var min = getNumber(props.Min);         // expected min sets to do today
        var tcurr = getNumber(props.Today);         // expected min sets to do today
        var level = getNumber(props.Level);         // drill level: if not in today
        //if ((tot == 0) || (props.Current === undefined) || (props.Current === null) || (props.Total == "")) {
        if (tot == 0) {
            //setCount(" ");      // may not be a Today drill
            setCount("L"+level);      // may not be a Today drill
            setColor("#bbbbbb");        // muted
            setBackground(props.Background);        // custom color to match the header
        } else {
            tcount = tot - curr;
            count = min - tcurr;
            if(curr >= tot) {
                // this seq is completed
                setCount("+("+curr+")");     // for state = 5, display total cum sets completed
                setColor("#707d7e");        // muted
            } else if (count > 0) {
                setCount(min - tcurr);
                setColor("#c0e4e7");        // bright
            } else if (count == 0) {
                setCount("DONE");
                setColor("#707d7e");        // muted
            } else {
                setCount("+("+tcurr+")");    // in case player does EXTRA sets for today
                setColor("#707d7e");        // muted
            }
        }
        console.log("seq_count.952:     TODAY CNT . . . name=",props.Name," tot=",tot, " curr=",curr, " min=",min, "  tcurr=",tcurr, "  cnt=", count, " tcnt=",tcount);

    }, [props.Min, props.Cum, props.Current, props.Total]);

    //console.log("avatar.193:  img=",props.Image);
                //<Container style={{position: "absolute", bottom: "5px" }} className={classes.count_text} ></Container>
    return (
        <React.Fragment>
            {(Count !== null) ?
                <Container className={classes.count_text} style={{color: Color, background: Background}}>
                    {Count}
                </Container>
            :
                ""
            }
        </React.Fragment>
    )
}

// general purpose eye candy icon
//
const candy_useStyles = makeStyles(theme => ({
    candy_container: {
        padding: '0',
        margin: '0',
        width: 'auto',
        height: 'auto',
        paddingRight: '5px',
        alignContent: 'center',
        alignItems: 'center',
    },
    candy_icon: {
        color: '#a5a5a9',
        paddingTop: '5px',
    },
}));

export const Candy = (props) => {
    const classes = candy_useStyles();
    const [ Image, setImage ] = useState("");

    useEffect(() => {
        //console.log("avatar.193:  img=",props.Image);
        switch(props.Type) {
            case "world":
                setImage(faGlobe);
                break;
            case "country":
                setImage(faFlag);
                break;
            case "city":
                setImage(faCity);
                break;
            case "team":
                setImage(faUsers);
                break;
            case "king":
                setImage(faCrown);
                break;
            case "trophy":
                setImage(faTrophy);
                break;
            case "player":
                setImage(faUser);
                break;
            default:
                setImage("");
                break;
        }
    }, [1]);

    return (
        <React.Fragment>
            {Image &&
            <Container id="candy_container" className={classes.candy_container} >
                <FontAwesomeIcon id="candy_icon" className={classes.candy_icon}
                    icon={Image} style={props.Style} />
            </Container>
            }

        </React.Fragment>
    )
}



// system reload button
const reload_useStyles = makeStyles(theme => ({
    reload_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '0',
        padding: '0',
        width: 'auto',
        color: 'rgba(200, 200, 240, 0.95)',
    },
}));

// DEV: ALSO CHECK handleUpdateWait() BELOW
//
export const Reload = (props) => {
    const classes = reload_useStyles();
    const Classes = UTIL_useStyles();
    //console.log("SVC-RELOAD.857: START RELOAD...");

    function handleReload() {
        processServiceWorkerReload();
        GATag("Misc", "Reload.Start", "", 0);		 // (cat, act, lab, val)
    }

    return (
        <Container id="reload_icon" className={classes.reload_container} >
            {INFO.show_download &&
                <Button id="bug_btn" className={classes.bug_icon} onClick={handleReload}>
                    <FontAwesomeIcon 
                        className={Classes.logo_icon}
                        icon={faCloudDownloadAlt}
                        style={{ fontSize: "1.7rem"}} />
                </Button>
            }
        </Container>
    )
}




// <Policy>  - Use this show plain text TOS or Privacy page
//
const policy_useStyles = makeStyles(theme => ({
    policy_container: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        overflow: 'auto',
    },
}));

export const Policy = (props) => {
    const classes = policy_useStyles();
    console.log("policy.2653:  ############ REACHED POLICY   len=", props.Text.length);

    return (
        <React.Fragment>
            <Container id="output" className={classes.policy_container} >
                {props.Text && props.Text.map((text, index) => {
                    if (text == "") {
                        return (
                            <p> <br/> </p>
                        )
                    } else {
                        return(
                        <Typography key={"txt_"+index}>
                            {text}
                        </Typography>
                        )
                    }
                })}
            </Container>
        </React.Fragment>
    )
}


// catch any exception
//
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    //logErrorToMyService(error, info);   // You can also log the error to an error reporting service
    console.error("exception.888:  EXECUTION EXCEPTION:  ", error, " info=", info);

    CreateVirtualSession(INFO.email, INFO.uid, "EXCEPTION");        // write it out
  }

  render() {
    if (this.state.hasError) {
      return <h1>ERROR: RESTART APPLICATION </h1>;   // You can render any custom fallback UI
    }
    return this.props.children;
  }
}
